// // import {
// //   useState,
// //   useEffect,
// //   useMemo,
// //   useCallback,
// //   useContext,
// //   useRef,
// // } from "react";
// // import { useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import { Bar, Line, Doughnut } from "react-chartjs-2";
// // import {
// //   Chart as ChartJS,
// //   ArcElement,
// //   Tooltip,
// //   Legend,
// //   CategoryScale,
// //   LinearScale,
// //   BarElement,
// //   PointElement,
// //   LineElement,
// //   Filler,
// //   Title,
// // } from "chart.js";
// // import { AuthContext } from "../context/AuthContext";
// // import { API_URL } from "../../Constants";

// // ChartJS.register(
// //   ArcElement,
// //   Tooltip,
// //   Legend,
// //   CategoryScale,
// //   LinearScale,
// //   BarElement,
// //   PointElement,
// //   LineElement,
// //   Filler,
// //   Title,
// // );

// // const authHeader = () => ({
// //   Authorization: `Bearer ${localStorage.getItem("token")}`,
// // });

// // const PALETTE = [
// //   "#673AB7",
// //   "#2196F3",
// //   "#00A896",
// //   "#F59E0B",
// //   "#EF4444",
// //   "#8B5CF6",
// //   "#10B981",
// //   "#EC4899",
// //   "#3B82F6",
// //   "#F97316",
// //   "#14B8A6",
// //   "#6366F1",
// // ];

// // const SINGLE_CHARTS = [
// //   { key: "funnel", label: "Funnel" },
// //   { key: "pyramid", label: "Pyramid" },
// //   { key: "bar", label: "Bar" },
// //   { key: "line", label: "Graph" },
// //   { key: "doughnut", label: "Donut" },
// // ];

// // const COMPARE_CHARTS = [
// //   { key: "stacked", label: "Stacked" },
// //   { key: "grouped", label: "Grouped" },
// //   { key: "share", label: "Share %" },
// //   { key: "lines", label: "Lines" },
// // ];

// // const LEVELS = [
// //   { key: "DIRECT", label: "Direct reports" },
// //   { key: "VICE_PRESIDENT", label: "Vice presidents" },
// //   { key: "MANAGER", label: "Managers" },
// //   { key: "TEAM_LEAD", label: "Team leads" },
// //   { key: "EXECUTIVE", label: "Executives" },
// // ];

// // const ROLE_LABEL = {
// //   COMPANY: "Company",
// //   VICE_PRESIDENT: "VP",
// //   MANAGER: "Manager",
// //   TEAM_LEAD: "Team lead",
// //   EXECUTIVE: "Executive",
// //   HR: "HR",
// //   UNASSIGNED: "Unassigned",
// //   OTHER: "Other",
// // };

// // const COMPARE_LIMIT_STEP = 25;

// // const fmt = (n) => Number(n || 0).toLocaleString("en-IN");

// // const pctOf = (a, b) => (b ? (a / b) * 100 : 0);

// // const roleLabel = (r) => {
// //   const key = String(r || "").toUpperCase();
// //   if (ROLE_LABEL[key]) return ROLE_LABEL[key];
// //   const text = key.replace(/_/g, " ").toLowerCase();
// //   return text ? text.replace(/^./, (c) => c.toUpperCase()) : "Member";
// // };

// // export const mergeOrder = (saved, statusList) => {
// //   const seen = new Set();
// //   const out = [];
// //   [...(saved || []), ...(statusList || [])].forEach((s) => {
// //     if (s && !seen.has(s)) {
// //       seen.add(s);
// //       out.push(s);
// //     }
// //   });
// //   return out;
// // };

// // export const applyPresentOrder = (full, present, nextPresent) => {
// //   const presentSet = new Set(present);
// //   let i = 0;
// //   return full.map((s) => (presentSet.has(s) ? nextPresent[i++] : s));
// // };

// // const toCountMap = (statuses) =>
// //   (statuses || []).reduce((acc, row) => {
// //     acc[row.status] = row.count;
// //     return acc;
// //   }, {});

// // const daysLabel = (d) => {
// //   if (d === null || d === undefined) return "No interaction yet";
// //   if (d === 0) return "Today";
// //   return `${d} day${d === 1 ? "" : "s"} ago`;
// // };

// // const LF_CSS = `
// //   .lf-root { min-height: 100vh; background: #f7f8fc; color: #1a1f36; font-family: inherit; padding-bottom: 48px; }
// //   .lf-top { background: rgba(255,255,255,.9); backdrop-filter: blur(10px); border-bottom: 1px solid #e5e9f0; padding: 16px 28px; display: flex; align-items: center; justify-content: space-between; gap: 12px; position: sticky; top: 0; z-index: 10; flex-wrap: wrap; }
// //   .lf-title { font-size: 20px; font-weight: 700; color: #673AB7; margin: 0; letter-spacing: -0.3px; }
// //   .lf-sub { font-size: 12px; color: #6b7280; margin: 2px 0 0; }
// //   .lf-actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
// //   .lf-btn { border: 1px solid #d9dee8; background: #fff; color: #1a1f36; border-radius: 8px; padding: 7px 14px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all .15s; }
// //   .lf-btn:hover:not(:disabled) { border-color: #673AB7; color: #673AB7; }
// //   .lf-btn:disabled { opacity: .5; cursor: default; }
// //   .lf-btn.primary { background: #673AB7; border-color: #673AB7; color: #fff; }
// //   .lf-btn.primary:hover:not(:disabled) { background: #5b32a3; color: #fff; }
// //   .lf-body { max-width: 1280px; margin: 0 auto; padding: 22px 28px 0; display: flex; flex-direction: column; gap: 18px; }
// //   .lf-crumbs { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; font-size: 13px; }
// //   .lf-crumb { background: none; border: none; padding: 2px 4px; color: #673AB7; cursor: pointer; font-weight: 600; font-size: 13px; border-radius: 4px; }
// //   .lf-crumb:hover { background: #ede7f6; }
// //   .lf-crumb.last { color: #1a1f36; cursor: default; }
// //   .lf-crumb.last:hover { background: none; }
// //   .lf-crumb-sep { color: #b0b7c3; }
// //   .lf-kpis { display: grid; grid-template-columns: repeat(auto-fit, minmax(190px, 1fr)); gap: 14px; }
// //   .lf-kpi { background: #fff; border: 1px solid #e5e9f0; border-radius: 12px; padding: 14px 16px; box-shadow: 0 1px 3px rgba(0,0,0,.04); text-align: left; font: inherit; color: inherit; }
// //   button.lf-kpi { cursor: pointer; transition: all .15s; }
// //   button.lf-kpi:hover { border-color: #f59e0b; box-shadow: 0 3px 10px rgba(245,158,11,.18); }
// //   .lf-kpi-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: #6b7280; }
// //   .lf-kpi-value { font-size: 28px; font-weight: 800; margin-top: 4px; line-height: 1.1; }
// //   .lf-kpi-sub { font-size: 12px; color: #6b7280; margin-top: 2px; }
// //   .lf-kpi.warn .lf-kpi-value { color: #d97706; }
// //   .lf-card { background: #fff; border: 1px solid #e5e9f0; border-radius: 14px; padding: 18px; box-shadow: 0 1px 3px rgba(0,0,0,.04); position: relative; }
// //   .lf-card-head { display: flex; justify-content: space-between; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 14px; }
// //   .lf-card-title { font-size: 15px; font-weight: 700; margin: 0; }
// //   .lf-seg { display: inline-flex; background: #f0f2f7; border-radius: 9px; padding: 3px; gap: 2px; flex-wrap: wrap; }
// //   .lf-seg button { border: none; background: transparent; padding: 6px 12px; font-size: 12.5px; font-weight: 600; color: #4b5563; border-radius: 7px; cursor: pointer; }
// //   .lf-seg button.on { background: #fff; color: #673AB7; box-shadow: 0 1px 3px rgba(0,0,0,.12); }
// //   .lf-toolbar { display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }
// //   .lf-select { border: 1px solid #d9dee8; border-radius: 8px; padding: 7px 10px; font-size: 13px; background: #fff; color: #1a1f36; }
// //   .lf-check { display: inline-flex; align-items: center; gap: 6px; font-size: 12.5px; color: #4b5563; cursor: pointer; }
// //   .lf-chips { display: flex; flex-wrap: wrap; gap: 8px; }
// //   .lf-chip { display: inline-flex; align-items: center; gap: 4px; background: #fff; border: 1px solid #d9dee8; border-radius: 999px; padding: 3px 6px 3px 4px; font-size: 12.5px; cursor: grab; user-select: none; transition: all .12s; }
// //   .lf-chip.hidden { opacity: .45; }
// //   .lf-chip.drag { opacity: .4; }
// //   .lf-chip.over { border-color: #673AB7; background: #ede7f6; }
// //   .lf-chip-grip { color: #b0b7c3; font-size: 11px; padding: 0 2px; letter-spacing: -2px; }
// //   .lf-chip-dot { width: 9px; height: 9px; border-radius: 50%; flex: none; }
// //   .lf-chip-name { background: none; border: none; font: inherit; font-weight: 600; cursor: pointer; padding: 2px 4px; color: #1a1f36; }
// //   .lf-chip.hidden .lf-chip-name { text-decoration: line-through; }
// //   .lf-chip-arrow { border: none; background: none; cursor: pointer; color: #6b7280; font-size: 14px; line-height: 1; padding: 0 3px; border-radius: 4px; }
// //   .lf-chip-arrow:hover:not(:disabled) { background: #ede7f6; color: #673AB7; }
// //   .lf-chip-arrow:disabled { opacity: .25; cursor: default; }
// //   .lf-hint { font-size: 11.5px; color: #8a92a3; margin: 8px 0 0; }
// //   .lf-funnel { display: flex; flex-direction: column; gap: 6px; }
// //   .lf-funnel-row { display: grid; grid-template-columns: 150px 1fr 56px; align-items: center; gap: 10px; padding: 2px 0; border-radius: 6px; transition: background .12s; }
// //   .lf-funnel-row:hover { background: #f7f8fc; }
// //   .lf-funnel-label { font-size: 12.5px; font-weight: 600; text-align: right; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
// //   .lf-funnel-track { display: flex; justify-content: center; }
// //   .lf-funnel-bar { height: 32px; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 700; font-size: 13px; min-width: 40px; transition: width .35s ease; box-shadow: 0 1px 2px rgba(0,0,0,.12); }
// //   .lf-funnel-pct { font-size: 12px; color: #6b7280; }
// //   .lf-pyramid { width: 100%; max-width: 720px; display: block; margin: 0 auto; }
// //   .lf-pyramid .layer { transition: opacity .12s; cursor: default; }
// //   .lf-pyramid:hover .layer { opacity: .55; }
// //   .lf-pyramid .layer:hover { opacity: 1; }
// //   .lf-chart-box { position: relative; width: 100%; }
// //   .lf-donut-center { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; pointer-events: none; }
// //   .lf-donut-center b { display: block; font-size: 26px; }
// //   .lf-donut-center span { font-size: 11px; color: #6b7280; text-transform: uppercase; letter-spacing: .5px; }
// //   .lf-table-wrap { overflow-x: auto; }
// //   .lf-table { width: 100%; border-collapse: collapse; font-size: 13px; }
// //   .lf-table th { text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: .5px; color: #6b7280; padding: 8px 10px; border-bottom: 1px solid #e5e9f0; white-space: nowrap; }
// //   .lf-table th.sortable { cursor: pointer; }
// //   .lf-table th.sortable:hover { color: #673AB7; }
// //   .lf-table td { padding: 10px; border-bottom: 1px solid #f0f2f7; vertical-align: middle; }
// //   .lf-table tr.row:hover td { background: #faf8ff; }
// //   .lf-name { font-weight: 700; }
// //   .lf-role { display: inline-block; margin-left: 8px; font-size: 10.5px; font-weight: 700; padding: 2px 8px; border-radius: 999px; background: #ede7f6; color: #5b32a3; text-transform: uppercase; letter-spacing: .4px; }
// //   .lf-num { font-variant-numeric: tabular-nums; font-weight: 700; }
// //   .lf-mix { display: flex; height: 10px; border-radius: 5px; overflow: hidden; background: #eef0f5; min-width: 160px; }
// //   .lf-mix span { display: block; height: 100%; }
// //   .lf-attn { border: 1px solid #fcd34d; background: #fffbeb; color: #b45309; font-weight: 700; border-radius: 999px; padding: 3px 11px; font-size: 12px; cursor: pointer; }
// //   .lf-attn:hover { background: #fef3c7; }
// //   .lf-attn.zero { border-color: #e5e9f0; background: #f7f8fc; color: #9aa1af; cursor: default; }
// //   .lf-open { border: none; background: none; color: #673AB7; font-weight: 700; cursor: pointer; font-size: 12.5px; padding: 4px 8px; border-radius: 6px; }
// //   .lf-open:hover { background: #ede7f6; }
// //   .lf-empty { text-align: center; color: #8a92a3; padding: 36px 12px; font-size: 14px; }
// //   .lf-error { text-align: center; padding: 48px 12px; color: #b91c1c; }
// //   .lf-skel { background: linear-gradient(90deg, #eef0f5 25%, #f7f8fc 50%, #eef0f5 75%); background-size: 200% 100%; animation: lf-shimmer 1.2s infinite; border-radius: 10px; }
// //   @keyframes lf-shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
// //   .lf-dim { opacity: .55; pointer-events: none; transition: opacity .15s; }
// //   .lf-more { text-align: center; margin-top: 12px; }
// //   .lf-save { font-size: 12px; color: #6b7280; min-width: 70px; }
// //   .lf-overlay { position: fixed; inset: 0; background: rgba(17,24,39,.4); z-index: 50; display: flex; justify-content: flex-end; }
// //   .lf-drawer { background: #fff; width: min(560px, 100%); height: 100%; display: flex; flex-direction: column; box-shadow: -8px 0 30px rgba(0,0,0,.15); }
// //   .lf-drawer-head { padding: 16px 20px; border-bottom: 1px solid #e5e9f0; display: flex; justify-content: space-between; align-items: center; gap: 10px; }
// //   .lf-drawer-head h3 { margin: 0; font-size: 16px; }
// //   .lf-drawer-body { padding: 14px 20px 24px; overflow-y: auto; flex: 1; }
// //   .lf-lead { border: 1px solid #e5e9f0; border-radius: 10px; padding: 11px 13px; margin-bottom: 10px; }
// //   .lf-lead-top { display: flex; justify-content: space-between; gap: 8px; align-items: center; }
// //   .lf-lead-name { font-weight: 700; }
// //   .lf-lead-meta { font-size: 12px; color: #6b7280; margin-top: 4px; display: flex; flex-wrap: wrap; gap: 4px 14px; }
// //   .lf-pill { font-size: 11px; font-weight: 700; padding: 2px 9px; border-radius: 999px; color: #fff; white-space: nowrap; }
// //   .lf-days { font-size: 12px; font-weight: 700; color: #b45309; background: #fffbeb; border: 1px solid #fcd34d; border-radius: 999px; padding: 2px 9px; white-space: nowrap; }
// //   @media (max-width: 760px) {
// //     .lf-top { padding: 12px 14px; }
// //     .lf-body { padding: 14px 14px 0; }
// //     .lf-funnel-row { grid-template-columns: 90px 1fr 46px; }
// //   }
// // `;

// // const StatusChips = ({ items, hidden, colorOf, onReorder, onToggle }) => {
// //   const [dragFrom, setDragFrom] = useState(null);
// //   const [over, setOver] = useState(null);

// //   const move = (from, to) => {
// //     if (from === null || to === null || from === to) return;
// //     if (to < 0 || to >= items.length) return;
// //     const next = items.slice();
// //     const [moved] = next.splice(from, 1);
// //     next.splice(to, 0, moved);
// //     onReorder(next);
// //   };

// //   return (
// //     <div className="lf-chips">
// //       {items.map((s, i) => (
// //         <div
// //           key={s}
// //           draggable
// //           className={`lf-chip ${hidden.has(s) ? "hidden" : ""} ${dragFrom === i ? "drag" : ""} ${over === i && dragFrom !== i ? "over" : ""}`}
// //           onDragStart={(e) => {
// //             setDragFrom(i);
// //             e.dataTransfer.effectAllowed = "move";
// //             e.dataTransfer.setData("text/plain", s);
// //           }}
// //           onDragOver={(e) => {
// //             e.preventDefault();
// //             setOver(i);
// //           }}
// //           onDragLeave={() => setOver((cur) => (cur === i ? null : cur))}
// //           onDrop={(e) => {
// //             e.preventDefault();
// //             move(dragFrom, i);
// //             setDragFrom(null);
// //             setOver(null);
// //           }}
// //           onDragEnd={() => {
// //             setDragFrom(null);
// //             setOver(null);
// //           }}
// //         >
// //           <span className="lf-chip-grip" aria-hidden="true">
// //             ⋮⋮
// //           </span>
// //           <button
// //             type="button"
// //             className="lf-chip-arrow"
// //             aria-label={`Move ${s} earlier`}
// //             disabled={i === 0}
// //             onClick={() => move(i, i - 1)}
// //           >
// //             ‹
// //           </button>
// //           <span className="lf-chip-dot" style={{ background: colorOf(s) }} />
// //           <button
// //             type="button"
// //             className="lf-chip-name"
// //             title={hidden.has(s) ? "Click to show" : "Click to hide"}
// //             onClick={() => onToggle(s)}
// //           >
// //             {s}
// //           </button>
// //           <button
// //             type="button"
// //             className="lf-chip-arrow"
// //             aria-label={`Move ${s} later`}
// //             disabled={i === items.length - 1}
// //             onClick={() => move(i, i + 1)}
// //           >
// //             ›
// //           </button>
// //         </div>
// //       ))}
// //     </div>
// //   );
// // };

// // const FunnelChart = ({ rows, total, colorOf }) => {
// //   const max = Math.max(1, ...rows.map((r) => r.count));
// //   return (
// //     <div className="lf-funnel" role="list">
// //       {rows.map((r) => {
// //         const width = Math.max(6, (r.count / max) * 100);
// //         return (
// //           <div
// //             key={r.status}
// //             className="lf-funnel-row"
// //             role="listitem"
// //             title={`${r.status}: ${fmt(r.count)} leads (${pctOf(r.count, total).toFixed(1)}% of total)`}
// //           >
// //             <div className="lf-funnel-label">{r.status}</div>
// //             <div className="lf-funnel-track">
// //               <div
// //                 className="lf-funnel-bar"
// //                 style={{ width: `${width}%`, background: colorOf(r.status) }}
// //               >
// //                 {fmt(r.count)}
// //               </div>
// //             </div>
// //             <div className="lf-funnel-pct">
// //               {pctOf(r.count, total).toFixed(1)}%
// //             </div>
// //           </div>
// //         );
// //       })}
// //     </div>
// //   );
// // };

// // const PyramidChart = ({ rows, total, colorOf }) => {
// //   const W = 700;
// //   const H = 400;
// //   const top = 12;
// //   const bottom = H - 12;
// //   const pad = 16;
// //   const cx = W / 2 - 40;
// //   const usable = bottom - top;
// //   const sum = rows.reduce((a, r) => a + r.count, 0) || 1;
// //   const raw = rows.map((r) => Math.max(0.055, r.count / sum));
// //   const rawSum = raw.reduce((a, b) => a + b, 0);
// //   const heights = raw.map((h) => (h / rawSum) * usable);
// //   const halfAt = (y) => ((y - top) / usable) * (cx - pad);

// //   let y = top;
// //   const layers = rows.map((r, i) => {
// //     const y0 = y;
// //     const y1 = y + heights[i];
// //     y = y1;
// //     const a = halfAt(y0);
// //     const b = halfAt(y1 - 1);
// //     const label = `${r.status} · ${fmt(r.count)}`;
// //     const est = label.length * 6.6;
// //     const midHalf = (halfAt(y0) + halfAt(y1)) / 2;
// //     let inside = midHalf * 2 - 18 >= est && heights[i] >= 18;
// //     const outsideFits = cx + midHalf + 10 + est <= W - 4;
// //     if (!inside && !outsideFits) inside = true;
// //     return {
// //       key: r.status,
// //       points: `${cx - a},${y0} ${cx + a},${y0} ${cx + b},${y1 - 1} ${cx - b},${y1 - 1}`,
// //       mid: (y0 + y1) / 2,
// //       midHalf,
// //       label,
// //       inside,
// //       color: colorOf(r.status),
// //       tip: `${r.status}: ${fmt(r.count)} leads (${pctOf(r.count, total).toFixed(1)}% of total)`,
// //     };
// //   });

// //   return (
// //     <svg
// //       className="lf-pyramid"
// //       viewBox={`0 0 ${W} ${H}`}
// //       role="img"
// //       aria-label="Lead pyramid by status"
// //     >
// //       {layers.map((l) => (
// //         <g key={l.key} className="layer">
// //           <title>{l.tip}</title>
// //           <polygon points={l.points} fill={l.color} />
// //           <text
// //             x={l.inside ? cx : cx + l.midHalf + 10}
// //             y={l.mid + 4}
// //             textAnchor={l.inside ? "middle" : "start"}
// //             fontSize="12"
// //             fontWeight="700"
// //             fill={l.inside ? "#fff" : "#1a1f36"}
// //           >
// //             {l.label}
// //           </text>
// //         </g>
// //       ))}
// //     </svg>
// //   );
// // };

// // const SingleChart = ({ type, rows, total, colorOf }) => {
// //   const labels = rows.map((r) => r.status);
// //   const values = rows.map((r) => r.count);
// //   const colors = rows.map((r) => colorOf(r.status));

// //   const tooltipLabel = (ctx) => {
// //     const v = ctx.parsed.y ?? ctx.parsed.x ?? ctx.parsed;
// //     return ` ${fmt(v)} leads (${pctOf(v, total).toFixed(1)}%)`;
// //   };

// //   if (type === "funnel")
// //     return <FunnelChart rows={rows} total={total} colorOf={colorOf} />;
// //   if (type === "pyramid")
// //     return <PyramidChart rows={rows} total={total} colorOf={colorOf} />;

// //   if (type === "bar") {
// //     return (
// //       <div
// //         className="lf-chart-box"
// //         style={{ height: Math.max(220, rows.length * 36 + 50) }}
// //       >
// //         <Bar
// //           data={{
// //             labels,
// //             datasets: [
// //               {
// //                 data: values,
// //                 backgroundColor: colors,
// //                 borderRadius: 6,
// //                 maxBarThickness: 26,
// //               },
// //             ],
// //           }}
// //           options={{
// //             indexAxis: "y",
// //             responsive: true,
// //             maintainAspectRatio: false,
// //             plugins: {
// //               legend: { display: false },
// //               tooltip: { callbacks: { label: tooltipLabel } },
// //             },
// //             scales: {
// //               x: { beginAtZero: true, grid: { color: "#f0f2f7" } },
// //               y: { grid: { display: false } },
// //             },
// //           }}
// //         />
// //       </div>
// //     );
// //   }

// //   if (type === "line") {
// //     return (
// //       <div className="lf-chart-box" style={{ height: 340 }}>
// //         <Line
// //           data={{
// //             labels,
// //             datasets: [
// //               {
// //                 data: values,
// //                 borderColor: "#673AB7",
// //                 backgroundColor: "rgba(103,58,183,0.14)",
// //                 pointBackgroundColor: colors,
// //                 pointBorderColor: "#fff",
// //                 pointRadius: 6,
// //                 pointHoverRadius: 8,
// //                 borderWidth: 2.5,
// //                 tension: 0.3,
// //                 fill: true,
// //               },
// //             ],
// //           }}
// //           options={{
// //             responsive: true,
// //             maintainAspectRatio: false,
// //             plugins: {
// //               legend: { display: false },
// //               tooltip: { callbacks: { label: tooltipLabel } },
// //             },
// //             scales: {
// //               y: { beginAtZero: true, grid: { color: "#f0f2f7" } },
// //               x: { grid: { display: false } },
// //             },
// //           }}
// //         />
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="lf-chart-box" style={{ height: 340 }}>
// //       <Doughnut
// //         data={{
// //           labels,
// //           datasets: [
// //             { data: values, backgroundColor: colors, borderWidth: 2 },
// //           ],
// //         }}
// //         options={{
// //           responsive: true,
// //           maintainAspectRatio: false,
// //           cutout: "62%",
// //           plugins: {
// //             legend: { position: "right", labels: { boxWidth: 12 } },
// //             tooltip: { callbacks: { label: tooltipLabel } },
// //           },
// //         }}
// //       />
// //       <div className="lf-donut-center" style={{ left: "35%" }}>
// //         <b>{fmt(total)}</b>
// //         <span>Leads</span>
// //       </div>
// //     </div>
// //   );
// // };

// // const CompareChart = ({ nodes, statuses, colorOf, mode, onDrill }) => {
// //   const maps = useMemo(() => nodes.map((n) => toCountMap(n.statuses)), [nodes]);
// //   const labels = nodes.map((n) => n.name);

// //   const datasets = statuses.map((s) => ({
// //     label: s,
// //     backgroundColor: colorOf(s),
// //     borderColor: colorOf(s),
// //     borderWidth: mode === "lines" ? 2.5 : 0,
// //     borderRadius: mode === "lines" ? 0 : 3,
// //     tension: 0.25,
// //     pointRadius: mode === "lines" ? 3 : 0,
// //     fill: false,
// //     data: nodes.map((n, i) => {
// //       const v = maps[i][s] || 0;
// //       return mode === "share" ? +pctOf(v, n.totalLeads).toFixed(1) : v;
// //     }),
// //   }));

// //   const handleClick = (_evt, elements) => {
// //     if (!elements || !elements.length) return;
// //     const node = nodes[elements[0].index];
// //     if (node && node.drillable) onDrill(node);
// //   };

// //   const common = {
// //     responsive: true,
// //     maintainAspectRatio: false,
// //     onClick: handleClick,
// //     interaction: { mode: "nearest", intersect: true },
// //     plugins: {
// //       legend: { position: "bottom", labels: { boxWidth: 12 } },
// //       tooltip: {
// //         callbacks: {
// //           label: (ctx) => {
// //             const v = ctx.parsed.x ?? ctx.parsed.y;
// //             return mode === "share"
// //               ? ` ${ctx.dataset.label}: ${v}%`
// //               : ` ${ctx.dataset.label}: ${fmt(v)}`;
// //           },
// //         },
// //       },
// //     },
// //   };

// //   if (mode === "lines") {
// //     return (
// //       <div className="lf-chart-box" style={{ height: 380 }}>
// //         <Line
// //           data={{ labels, datasets }}
// //           options={{
// //             ...common,
// //             scales: {
// //               y: { beginAtZero: true, grid: { color: "#f0f2f7" } },
// //               x: { grid: { display: false } },
// //             },
// //           }}
// //         />
// //       </div>
// //     );
// //   }

// //   const stacked = mode === "stacked" || mode === "share";
// //   const perNode = stacked ? 30 : Math.max(30, statuses.length * 11 + 12);
// //   return (
// //     <div
// //       className="lf-chart-box"
// //       style={{ height: Math.max(280, nodes.length * perNode + 110) }}
// //     >
// //       <Bar
// //         data={{ labels, datasets }}
// //         options={{
// //           ...common,
// //           indexAxis: "y",
// //           scales: {
// //             x: {
// //               stacked,
// //               beginAtZero: true,
// //               max: mode === "share" ? 100 : undefined,
// //               grid: { color: "#f0f2f7" },
// //               ticks: mode === "share" ? { callback: (v) => `${v}%` } : {},
// //             },
// //             y: { stacked, grid: { display: false } },
// //           },
// //         }}
// //       />
// //     </div>
// //   );
// // };

// // const MixBar = ({ node, order, colorOf }) => {
// //   const map = toCountMap(node.statuses);
// //   return (
// //     <div className="lf-mix">
// //       {order
// //         .filter((s) => map[s] > 0)
// //         .map((s) => (
// //           <span
// //             key={s}
// //             title={`${s}: ${fmt(map[s])}`}
// //             style={{
// //               width: `${pctOf(map[s], node.totalLeads)}%`,
// //               background: colorOf(s),
// //             }}
// //           />
// //         ))}
// //     </div>
// //   );
// // };

// // const AttentionDrawer = ({ state, onClose, onMore, colorOf }) => {
// //   if (!state.open) return null;
// //   return (
// //     <div className="lf-overlay" onClick={onClose}>
// //       <div
// //         className="lf-drawer"
// //         role="dialog"
// //         aria-modal="true"
// //         onClick={(e) => e.stopPropagation()}
// //       >
// //         <div className="lf-drawer-head">
// //           <h3>{state.title}</h3>
// //           <button type="button" className="lf-btn" onClick={onClose}>
// //             Close
// //           </button>
// //         </div>
// //         <div className="lf-drawer-body">
// //           {state.error && (
// //             <div className="lf-error">Could not load these leads.</div>
// //           )}
// //           {!state.error && !state.loading && state.items.length === 0 && (
// //             <div className="lf-empty">
// //               Nothing needs attention here. Nice work.
// //             </div>
// //           )}
// //           {state.items.map((l) => (
// //             <div className="lf-lead" key={l.leadId}>
// //               <div className="lf-lead-top">
// //                 <span className="lf-lead-name">{l.name || "Unnamed lead"}</span>
// //                 <span className="lf-days">{l.daysInStatus}d in status</span>
// //               </div>
// //               <div className="lf-lead-meta">
// //                 <span
// //                   className="lf-pill"
// //                   style={{ background: colorOf(l.status || "") }}
// //                 >
// //                   {l.status || "Unknown"}
// //                 </span>
// //                 {l.phone && <span>{l.phone}</span>}
// //                 <span>{l.executiveName || "Unassigned"}</span>
// //                 {l.projectName && <span>{l.projectName}</span>}
// //                 <span>Last interaction: {daysLabel(l.daysSinceLastInteraction)}</span>
// //               </div>
// //             </div>
// //           ))}
// //           {state.loading && (
// //             <div className="lf-skel" style={{ height: 70, marginBottom: 10 }} />
// //           )}
// //           {state.hasNext && !state.loading && (
// //             <div className="lf-more">
// //               <button type="button" className="lf-btn" onClick={onMore}>
// //                 Load more
// //               </button>
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // const LeadFunnel = () => {
// //   const navigate = useNavigate();
// //   const { user } = useContext(AuthContext);
// //   const userId = user?.id;

// //   const [nodeId, setNodeId] = useState(null);
// //   const [view, setView] = useState("overview");
// //   const [level, setLevel] = useState("DIRECT");
// //   const [chartType, setChartType] = useState("funnel");
// //   const [compareMode, setCompareMode] = useState("stacked");
// //   const [showEmpty, setShowEmpty] = useState(false);
// //   const [hidden, setHidden] = useState(() => new Set());
// //   const [order, setOrder] = useState([]);
// //   const [data, setData] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [saveState, setSaveState] = useState("");
// //   const [sort, setSort] = useState({ key: "total", dir: "desc" });
// //   const [compareLimit, setCompareLimit] = useState(COMPARE_LIMIT_STEP);
// //   const [attn, setAttn] = useState({
// //     open: false,
// //     title: "",
// //     params: {},
// //     items: [],
// //     page: 0,
// //     hasNext: false,
// //     loading: false,
// //     error: false,
// //   });

// //   const reqRef = useRef(0);
// //   const saveTimer = useRef(null);
// //   const attnReq = useRef(0);

// //   const levelParam = view === "compare" && level !== "DIRECT" ? level : "";

// //   const load = useCallback(
// //     async (silent) => {
// //       if (!userId) return;
// //       const id = ++reqRef.current;
// //       if (!silent) setLoading(true);
// //       try {
// //         const r = await axios.get(
// //           `${API_URL}/api/lead-insights/funnel/${userId}`,
// //           {
// //             headers: authHeader(),
// //             params: {
// //               nodeId: nodeId || undefined,
// //               level: levelParam || undefined,
// //             },
// //           },
// //         );
// //         if (id !== reqRef.current) return;
// //         setData(r.data);
// //         setError(null);
// //         setOrder((prev) => mergeOrder(prev, r.data.statusList));
// //       } catch (e) {
// //         if (id !== reqRef.current) return;
// //         setError(e.response?.status === 403 ? "forbidden" : "failed");
// //       } finally {
// //         if (id === reqRef.current) setLoading(false);
// //       }
// //     },
// //     [userId, nodeId, levelParam],
// //   );

// //   useEffect(() => {
// //     load(false);
// //   }, [load]);

// //   useEffect(() => {
// //     const t = setInterval(() => {
// //       if (!document.hidden) load(true);
// //     }, 60000);
// //     return () => clearInterval(t);
// //   }, [load]);

// //   useEffect(() => {
// //     if (!userId) return;
// //     axios
// //       .get(`${API_URL}/api/lead-insights/funnel-preferences/${userId}`, {
// //         headers: authHeader(),
// //       })
// //       .then((r) => {
// //         const saved = r.data?.statusOrder || [];
// //         setOrder((prev) => mergeOrder(saved, prev));
// //         if (SINGLE_CHARTS.some((c) => c.key === r.data?.chartType)) {
// //           setChartType(r.data.chartType);
// //         }
// //       })
// //       .catch(() => {});
// //   }, [userId]);

// //   useEffect(() => () => clearTimeout(saveTimer.current), []);

// //   const savePrefs = useCallback(
// //     (body, delay) => {
// //       if (!userId) return;
// //       clearTimeout(saveTimer.current);
// //       setSaveState("Saving…");
// //       saveTimer.current = setTimeout(() => {
// //         axios
// //           .put(
// //             `${API_URL}/api/lead-insights/funnel-preferences/${userId}`,
// //             body,
// //             { headers: authHeader() },
// //           )
// //           .then(() => setSaveState("Saved"))
// //           .catch(() => setSaveState("Could not save"));
// //       }, delay);
// //     },
// //     [userId],
// //   );

// //   const present = useMemo(() => data?.statusList || [], [data]);

// //   const orderedPresent = useMemo(
// //     () => order.filter((s) => present.includes(s)),
// //     [order, present],
// //   );

// //   const colorOf = useMemo(() => {
// //     const names = [...new Set([...order, ...present])].sort((a, b) =>
// //       a.localeCompare(b),
// //     );
// //     const index = new Map(names.map((n, i) => [n, i]));
// //     return (s) => PALETTE[(index.get(s) ?? 0) % PALETTE.length];
// //   }, [order, present]);

// //   const onReorder = (nextPresent) => {
// //     const nextFull = applyPresentOrder(order, orderedPresent, nextPresent);
// //     setOrder(nextFull);
// //     savePrefs({ statusOrder: nextFull }, 500);
// //   };

// //   const onToggleStatus = (s) =>
// //     setHidden((prev) => {
// //       const next = new Set(prev);
// //       if (next.has(s)) next.delete(s);
// //       else next.add(s);
// //       return next;
// //     });

// //   const onChartType = (key) => {
// //     setChartType(key);
// //     savePrefs({ chartType: key }, 0);
// //   };

// //   const drill = (entry) => {
// //     if (!entry || !entry.drillable) return;
// //     setNodeId(entry.id);
// //     setView("overview");
// //     setLevel("DIRECT");
// //     setCompareLimit(COMPARE_LIMIT_STEP);
// //     window.scrollTo({ top: 0, behavior: "smooth" });
// //   };

// //   const totalLeads = data?.total?.totalLeads || 0;
// //   const totalMap = useMemo(() => toCountMap(data?.total?.statuses), [data]);

// //   const singleRows = useMemo(
// //     () =>
// //       orderedPresent
// //         .filter((s) => !hidden.has(s))
// //         .map((s) => ({ status: s, count: totalMap[s] || 0 }))
// //         .filter((r) => showEmpty || r.count > 0),
// //     [orderedPresent, hidden, totalMap, showEmpty],
// //   );

// //   const levelReady =
// //     level === "DIRECT" || (data?.levelRole || "").toUpperCase() === level;

// //   const compareNodes = useMemo(() => {
// //     if (view !== "compare" || !data || !levelReady) return [];
// //     const list = level === "DIRECT" ? data.children : data.levelNodes;
// //     return (list || []).filter((n) => n.totalLeads > 0 || showEmpty);
// //   }, [view, data, level, levelReady, showEmpty]);

// //   const shownCompareNodes = useMemo(
// //     () => compareNodes.slice(0, compareLimit),
// //     [compareNodes, compareLimit],
// //   );

// //   const compareStatuses = useMemo(() => {
// //     const maps = shownCompareNodes.map((n) => toCountMap(n.statuses));
// //     return orderedPresent
// //       .filter((s) => !hidden.has(s))
// //       .filter((s) => showEmpty || maps.some((m) => (m[s] || 0) > 0));
// //   }, [shownCompareNodes, orderedPresent, hidden, showEmpty]);

// //   const tableRows = useMemo(() => {
// //     const rows = (data?.children || []).slice();
// //     const dir = sort.dir === "asc" ? 1 : -1;
// //     rows.sort((a, b) => {
// //       if (sort.key === "name") return dir * a.name.localeCompare(b.name);
// //       if (sort.key === "attention") return dir * (a.attention - b.attention);
// //       return dir * (a.totalLeads - b.totalLeads);
// //     });
// //     return rows;
// //   }, [data, sort]);

// //   const toggleSort = (key) =>
// //     setSort((cur) =>
// //       cur.key === key
// //         ? { key, dir: cur.dir === "asc" ? "desc" : "asc" }
// //         : { key, dir: key === "name" ? "asc" : "desc" },
// //     );

// //   const sortMark = (key) =>
// //     sort.key === key ? (sort.dir === "asc" ? " ▲" : " ▼") : "";

// //   const fetchAttention = useCallback(
// //     async (params, page, replace) => {
// //       const id = ++attnReq.current;
// //       setAttn((cur) => ({ ...cur, loading: true, error: false }));
// //       try {
// //         const r = await axios.get(
// //           `${API_URL}/api/lead-insights/needs-attention/${userId}`,
// //           { headers: authHeader(), params: { page, size: 25, ...params } },
// //         );
// //         if (id !== attnReq.current) return;
// //         setAttn((cur) => ({
// //           ...cur,
// //           loading: false,
// //           page,
// //           hasNext: !!r.data.hasNext,
// //           items: replace ? r.data.items : [...cur.items, ...r.data.items],
// //         }));
// //       } catch (e) {
// //         if (id !== attnReq.current) return;
// //         setAttn((cur) => ({ ...cur, loading: false, error: true }));
// //       }
// //     },
// //     [userId],
// //   );

// //   const openAttention = (entry) => {
// //     if (!entry || entry.listable === false) return;
// //     const params =
// //       entry.id === "UNASSIGNED"
// //         ? { executiveId: "UNASSIGNED" }
// //         : { nodeId: entry.id };
// //     setAttn({
// //       open: true,
// //       title: `${entry.name} · needs attention`,
// //       params,
// //       items: [],
// //       page: 0,
// //       hasNext: false,
// //       loading: true,
// //       error: false,
// //     });
// //     fetchAttention(params, 0, true);
// //   };

// //   const closeAttention = () => {
// //     attnReq.current += 1;
// //     setAttn((cur) => ({ ...cur, open: false }));
// //   };

// //   if (error === "forbidden") {
// //     return (
// //       <>
// //         <style>{LF_CSS}</style>
// //         <div className="lf-root">
// //           <div className="lf-error">
// //             You do not have access to Leads, so the funnel is unavailable.
// //           </div>
// //         </div>
// //       </>
// //     );
// //   }

// //   const node = data?.node;
// //   const attention = data?.total?.attention || 0;
// //   const ownLeads = data?.own?.totalLeads || 0;
// //   const hasChildren = (data?.children || []).length > 0;

// //   return (
// //     <>
// //       <style>{LF_CSS}</style>
// //       <div className="lf-root">
// //         <div className="lf-top">
// //           <div>
// //             <h1 className="lf-title">Lead Funnel</h1>
// //             <p className="lf-sub">
// //               {data
// //                 ? `Updated ${new Date(data.generatedAt).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })} · attention = no status change for ${data.staleAfterDays}+ days`
// //                 : "Loading…"}
// //             </p>
// //           </div>
// //           <div className="lf-actions">
// //             <span className="lf-save">{saveState}</span>
// //             <button
// //               type="button"
// //               className="lf-btn"
// //               onClick={() => load(false)}
// //               disabled={loading}
// //             >
// //               Refresh
// //             </button>
// //             <button
// //               type="button"
// //               className="lf-btn primary"
// //               onClick={() => navigate("/dashboard")}
// //             >
// //               ← Dashboard
// //             </button>
// //           </div>
// //         </div>

// //         <div className="lf-body">
// //           {error === "failed" && !data && (
// //             <div className="lf-error">
// //               Could not load the funnel.{" "}
// //               <button type="button" className="lf-btn" onClick={() => load(false)}>
// //                 Try again
// //               </button>
// //             </div>
// //           )}

// //           {!data && !error && (
// //             <>
// //               <div className="lf-skel" style={{ height: 90 }} />
// //               <div className="lf-skel" style={{ height: 380 }} />
// //             </>
// //           )}

// //           {data && (
// //             <div className={loading ? "lf-dim" : ""} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
// //               <div className="lf-crumbs">
// //                 {(data.breadcrumb || []).map((c, i, arr) => {
// //                   const last = i === arr.length - 1;
// //                   return (
// //                     <span key={c.id} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
// //                       <button
// //                         type="button"
// //                         className={`lf-crumb ${last ? "last" : ""}`}
// //                         onClick={() => !last && setNodeId(c.id)}
// //                       >
// //                         {c.name}
// //                       </button>
// //                       {!last && <span className="lf-crumb-sep">›</span>}
// //                     </span>
// //                   );
// //                 })}
// //                 {node && <span className="lf-role">{roleLabel(node.role)}</span>}
// //               </div>

// //               <div className="lf-kpis">
// //                 <div className="lf-kpi">
// //                   <div className="lf-kpi-label">Total leads</div>
// //                   <div className="lf-kpi-value">{fmt(totalLeads)}</div>
// //                   <div className="lf-kpi-sub">
// //                     {hasChildren ? "Including everyone below" : "Assigned to this person"}
// //                   </div>
// //                 </div>
// //                 <button
// //                   type="button"
// //                   className="lf-kpi warn"
// //                   onClick={() => openAttention(node)}
// //                   disabled={attention === 0}
// //                 >
// //                   <div className="lf-kpi-label">Needs attention</div>
// //                   <div className="lf-kpi-value">{fmt(attention)}</div>
// //                   <div className="lf-kpi-sub">
// //                     {pctOf(attention, totalLeads).toFixed(1)}% of leads · click to view
// //                   </div>
// //                 </button>
// //                 <div className="lf-kpi">
// //                   <div className="lf-kpi-label">Statuses in play</div>
// //                   <div className="lf-kpi-value">{fmt(singleRows.filter((r) => r.count > 0).length)}</div>
// //                   <div className="lf-kpi-sub">With at least one lead</div>
// //                 </div>
// //                 {hasChildren && (
// //                   <div className="lf-kpi">
// //                     <div className="lf-kpi-label">Held directly</div>
// //                     <div className="lf-kpi-value">{fmt(ownLeads)}</div>
// //                     <div className="lf-kpi-sub">
// //                       Leads assigned to {node?.name || "this person"} themselves
// //                     </div>
// //                   </div>
// //                 )}
// //               </div>

// //               <div className="lf-card">
// //                 <div className="lf-card-head">
// //                   <h2 className="lf-card-title">Status order</h2>
// //                   <label className="lf-check">
// //                     <input
// //                       type="checkbox"
// //                       checked={showEmpty}
// //                       onChange={(e) => setShowEmpty(e.target.checked)}
// //                     />
// //                     Show empty statuses
// //                   </label>
// //                 </div>
// //                 <StatusChips
// //                   items={orderedPresent}
// //                   hidden={hidden}
// //                   colorOf={colorOf}
// //                   onReorder={onReorder}
// //                   onToggle={onToggleStatus}
// //                 />
// //                 <p className="lf-hint">
// //                   Drag a status (or use the arrows) to set the order. It is saved for you. Click a name to hide or show it.
// //                 </p>
// //               </div>

// //               <div className="lf-card">
// //                 <div className="lf-card-head">
// //                   <div className="lf-seg" role="group" aria-label="View">
// //                     <button
// //                       type="button"
// //                       className={view === "overview" ? "on" : ""}
// //                       aria-pressed={view === "overview"}
// //                       onClick={() => setView("overview")}
// //                     >
// //                       {node?.name ? `${node.name}` : "Overview"}
// //                     </button>
// //                     <button
// //                       type="button"
// //                       className={view === "compare" ? "on" : ""}
// //                       aria-pressed={view === "compare"}
// //                       onClick={() => setView("compare")}
// //                     >
// //                       Compare side by side
// //                     </button>
// //                   </div>

// //                   <div className="lf-toolbar">
// //                     {view === "compare" && (
// //                       <select
// //                         className="lf-select"
// //                         value={level}
// //                         onChange={(e) => {
// //                           setLevel(e.target.value);
// //                           setCompareLimit(COMPARE_LIMIT_STEP);
// //                         }}
// //                         aria-label="Compare level"
// //                       >
// //                         {LEVELS.map((l) => (
// //                           <option key={l.key} value={l.key}>
// //                             {l.label}
// //                           </option>
// //                         ))}
// //                       </select>
// //                     )}
// //                     <div className="lf-seg" role="group" aria-label="Chart type">
// //                       {(view === "compare" ? COMPARE_CHARTS : SINGLE_CHARTS).map((c) => {
// //                         const active = view === "compare" ? compareMode === c.key : chartType === c.key;
// //                         return (
// //                           <button
// //                             key={c.key}
// //                             type="button"
// //                             className={active ? "on" : ""}
// //                             aria-pressed={active}
// //                             onClick={() =>
// //                               view === "compare" ? setCompareMode(c.key) : onChartType(c.key)
// //                             }
// //                           >
// //                             {c.label}
// //                           </button>
// //                         );
// //                       })}
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {view === "overview" && (
// //                   <>
// //                     {singleRows.length === 0 ? (
// //                       <div className="lf-empty">No leads to show for this selection yet.</div>
// //                     ) : (
// //                       <SingleChart
// //                         type={chartType}
// //                         rows={singleRows}
// //                         total={totalLeads}
// //                         colorOf={colorOf}
// //                       />
// //                     )}
// //                   </>
// //                 )}

// //                 {view === "compare" && (
// //                   <>
// //                     {!levelReady && <div className="lf-skel" style={{ height: 280 }} />}
// //                     {levelReady && shownCompareNodes.length === 0 && (
// //                       <div className="lf-empty">
// //                         No {LEVELS.find((l) => l.key === level)?.label.toLowerCase()} with leads under {node?.name}.
// //                       </div>
// //                     )}
// //                     {levelReady && shownCompareNodes.length > 0 && (
// //                       <>
// //                         <CompareChart
// //                           nodes={shownCompareNodes}
// //                           statuses={compareStatuses}
// //                           colorOf={colorOf}
// //                           mode={compareMode}
// //                           onDrill={drill}
// //                         />
// //                         <p className="lf-hint">Click a bar to open that person's funnel.</p>
// //                         {compareNodes.length > shownCompareNodes.length && (
// //                           <div className="lf-more">
// //                             <button
// //                               type="button"
// //                               className="lf-btn"
// //                               onClick={() => setCompareLimit((n) => n + COMPARE_LIMIT_STEP)}
// //                             >
// //                               Show more ({compareNodes.length - shownCompareNodes.length} left)
// //                             </button>
// //                           </div>
// //                         )}
// //                       </>
// //                     )}
// //                   </>
// //                 )}
// //               </div>

// //               {hasChildren && (
// //                 <div className="lf-card">
// //                   <div className="lf-card-head">
// //                     <h2 className="lf-card-title">
// //                       {node?.role === "COMPANY" ? "Teams and people" : `Reporting to ${node?.name}`}
// //                     </h2>
// //                   </div>
// //                   <div className="lf-table-wrap">
// //                     <table className="lf-table">
// //                       <thead>
// //                         <tr>
// //                           <th className="sortable" onClick={() => toggleSort("name")}>
// //                             Name{sortMark("name")}
// //                           </th>
// //                           <th className="sortable" onClick={() => toggleSort("total")}>
// //                             Leads{sortMark("total")}
// //                           </th>
// //                           <th>Status mix</th>
// //                           <th className="sortable" onClick={() => toggleSort("attention")}>
// //                             Needs attention{sortMark("attention")}
// //                           </th>
// //                           <th />
// //                         </tr>
// //                       </thead>
// //                       <tbody>
// //                         {tableRows.map((row) => (
// //                           <tr className="row" key={row.id}>
// //                             <td>
// //                               <span className="lf-name">{row.name}</span>
// //                               <span className="lf-role">{roleLabel(row.role)}</span>
// //                             </td>
// //                             <td className="lf-num">{fmt(row.totalLeads)}</td>
// //                             <td>
// //                               <MixBar node={row} order={orderedPresent} colorOf={colorOf} />
// //                             </td>
// //                             <td>
// //                               <button
// //                                 type="button"
// //                                 className={`lf-attn ${row.attention === 0 || row.listable === false ? "zero" : ""}`}
// //                                 disabled={row.attention === 0 || row.listable === false}
// //                                 onClick={() => openAttention(row)}
// //                               >
// //                                 {fmt(row.attention)}
// //                               </button>
// //                             </td>
// //                             <td>
// //                               {row.drillable && (
// //                                 <button type="button" className="lf-open" onClick={() => drill(row)}>
// //                                   Open ›
// //                                 </button>
// //                               )}
// //                             </td>
// //                           </tr>
// //                         ))}
// //                       </tbody>
// //                     </table>
// //                   </div>
// //                 </div>
// //               )}
// //             </div>
// //           )}
// //         </div>

// //         <AttentionDrawer
// //           state={attn}
// //           onClose={closeAttention}
// //           onMore={() => fetchAttention(attn.params, attn.page + 1, false)}
// //           colorOf={colorOf}
// //         />
// //       </div>
// //     </>
// //   );
// // };

// // export default LeadFunnel;









// import {
//   useState,
//   useEffect,
//   useMemo,
//   useCallback,
//   useContext,
//   useRef,
// } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Bar, Line, Doughnut } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   Filler,
//   Title,
// } from "chart.js";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";

// ChartJS.register(
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   Filler,
//   Title,
// );

// const authHeader = () => ({
//   Authorization: `Bearer ${localStorage.getItem("token")}`,
// });

// const PALETTE = [
//   "#673AB7",
//   "#2196F3",
//   "#00A896",
//   "#F59E0B",
//   "#EF4444",
//   "#8B5CF6",
//   "#10B981",
//   "#EC4899",
//   "#3B82F6",
//   "#F97316",
//   "#14B8A6",
//   "#6366F1",
// ];

// const SINGLE_CHARTS = [
//   { key: "funnel", label: "Funnel" },
//   { key: "pyramid", label: "Pyramid" },
//   { key: "bar", label: "Bar" },
//   { key: "line", label: "Graph" },
//   { key: "doughnut", label: "Donut" },
// ];

// const COMPARE_CHARTS = [
//   { key: "stacked", label: "Stacked" },
//   { key: "grouped", label: "Grouped" },
//   { key: "share", label: "Share %" },
//   { key: "lines", label: "Lines" },
// ];

// const LEVELS = [
//   { key: "DIRECT", label: "Direct reports" },
//   { key: "VICE_PRESIDENT", label: "Vice presidents" },
//   { key: "MANAGER", label: "Managers" },
//   { key: "TEAM_LEAD", label: "Team leads" },
//   { key: "EXECUTIVE", label: "Executives" },
// ];

// const ROLE_LABEL = {
//   COMPANY: "Company",
//   VICE_PRESIDENT: "VP",
//   MANAGER: "Manager",
//   TEAM_LEAD: "Team lead",
//   EXECUTIVE: "Executive",
//   HR: "HR",
//   UNASSIGNED: "Unassigned",
//   OTHER: "Other",
// };

// const COMPARE_LIMIT_STEP = 25;

// const fmt = (n) => Number(n || 0).toLocaleString("en-IN");

// const pctOf = (a, b) => (b ? (a / b) * 100 : 0);

// const roleLabel = (r) => {
//   const key = String(r || "").toUpperCase();
//   if (ROLE_LABEL[key]) return ROLE_LABEL[key];
//   const text = key.replace(/_/g, " ").toLowerCase();
//   return text ? text.replace(/^./, (c) => c.toUpperCase()) : "Member";
// };

// export const mergeOrder = (saved, statusList) => {
//   const seen = new Set();
//   const out = [];
//   [...(saved || []), ...(statusList || [])].forEach((s) => {
//     if (s && !seen.has(s)) {
//       seen.add(s);
//       out.push(s);
//     }
//   });
//   return out;
// };

// export const applyPresentOrder = (full, present, nextPresent) => {
//   const presentSet = new Set(present);
//   let i = 0;
//   return full.map((s) => (presentSet.has(s) ? nextPresent[i++] : s));
// };

// const toCountMap = (statuses) =>
//   (statuses || []).reduce((acc, row) => {
//     acc[row.status] = row.count;
//     return acc;
//   }, {});

// const daysLabel = (d) => {
//   if (d === null || d === undefined) return "No interaction yet";
//   if (d === 0) return "Today";
//   return `${d} day${d === 1 ? "" : "s"} ago`;
// };

// const LF_CSS = `
//   .lf-root { min-height: 100vh; background: #f7f8fc; color: #1a1f36; font-family: inherit; padding-bottom: 48px; }
//   .lf-top { background: rgba(255,255,255,.9); backdrop-filter: blur(10px); border-bottom: 1px solid #e5e9f0; padding: 16px 28px; display: flex; align-items: center; justify-content: space-between; gap: 12px; position: sticky; top: 0; z-index: 10; flex-wrap: wrap; }
//   .lf-title { font-size: 20px; font-weight: 700; color: #673AB7; margin: 0; letter-spacing: -0.3px; }
//   .lf-sub { font-size: 12px; color: #6b7280; margin: 2px 0 0; }
//   .lf-actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
//   .lf-btn { border: 1px solid #d9dee8; background: #fff; color: #1a1f36; border-radius: 8px; padding: 7px 14px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all .15s; }
//   .lf-btn:hover:not(:disabled) { border-color: #673AB7; color: #673AB7; }
//   .lf-btn:disabled { opacity: .5; cursor: default; }
//   .lf-btn.primary { background: #673AB7; border-color: #673AB7; color: #fff; }
//   .lf-btn.primary:hover:not(:disabled) { background: #5b32a3; color: #fff; }
//   .lf-body { max-width: 1280px; margin: 0 auto; padding: 22px 28px 0; display: flex; flex-direction: column; gap: 18px; }
//   .lf-crumbs { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; font-size: 13px; }
//   .lf-crumb { background: none; border: none; padding: 2px 4px; color: #673AB7; cursor: pointer; font-weight: 600; font-size: 13px; border-radius: 4px; }
//   .lf-crumb:hover { background: #ede7f6; }
//   .lf-crumb.last { color: #1a1f36; cursor: default; }
//   .lf-crumb.last:hover { background: none; }
//   .lf-crumb-sep { color: #b0b7c3; }
//   .lf-kpis { display: grid; grid-template-columns: repeat(auto-fit, minmax(190px, 1fr)); gap: 14px; }
//   .lf-kpi { background: #fff; border: 1px solid #e5e9f0; border-radius: 12px; padding: 14px 16px; box-shadow: 0 1px 3px rgba(0,0,0,.04); text-align: left; font: inherit; color: inherit; }
//   button.lf-kpi { cursor: pointer; transition: all .15s; }
//   button.lf-kpi:hover { border-color: #f59e0b; box-shadow: 0 3px 10px rgba(245,158,11,.18); }
//   .lf-kpi-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: #6b7280; }
//   .lf-kpi-value { font-size: 28px; font-weight: 800; margin-top: 4px; line-height: 1.1; }
//   .lf-kpi-sub { font-size: 12px; color: #6b7280; margin-top: 2px; }
//   .lf-kpi.warn .lf-kpi-value { color: #d97706; }
//   .lf-card { background: #fff; border: 1px solid #e5e9f0; border-radius: 14px; padding: 18px; box-shadow: 0 1px 3px rgba(0,0,0,.04); position: relative; }
//   .lf-card-head { display: flex; justify-content: space-between; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 14px; }
//   .lf-card-title { font-size: 15px; font-weight: 700; margin: 0; }
//   .lf-seg { display: inline-flex; background: #f0f2f7; border-radius: 9px; padding: 3px; gap: 2px; flex-wrap: wrap; }
//   .lf-seg button { border: none; background: transparent; padding: 6px 12px; font-size: 12.5px; font-weight: 600; color: #4b5563; border-radius: 7px; cursor: pointer; }
//   .lf-seg button.on { background: #fff; color: #673AB7; box-shadow: 0 1px 3px rgba(0,0,0,.12); }
//   .lf-toolbar { display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }
//   .lf-select { border: 1px solid #d9dee8; border-radius: 8px; padding: 7px 10px; font-size: 13px; background: #fff; color: #1a1f36; }
//   .lf-check { display: inline-flex; align-items: center; gap: 6px; font-size: 12.5px; color: #4b5563; cursor: pointer; }
//   .lf-chips { display: flex; flex-wrap: wrap; gap: 8px; }
//   .lf-chip { display: inline-flex; align-items: center; gap: 4px; background: #fff; border: 1px solid #d9dee8; border-radius: 999px; padding: 3px 6px 3px 4px; font-size: 12.5px; cursor: grab; user-select: none; transition: all .12s; }
//   .lf-chip.hidden { opacity: .45; }
//   .lf-chip.drag { opacity: .4; }
//   .lf-chip.over { border-color: #673AB7; background: #ede7f6; }
//   .lf-chip-grip { color: #b0b7c3; font-size: 11px; padding: 0 2px; letter-spacing: -2px; }
//   .lf-chip-dot { width: 9px; height: 9px; border-radius: 50%; flex: none; }
//   .lf-chip-name { background: none; border: none; font: inherit; font-weight: 600; cursor: pointer; padding: 2px 4px; color: #1a1f36; }
//   .lf-chip.hidden .lf-chip-name { text-decoration: line-through; }
//   .lf-chip-arrow { border: none; background: none; cursor: pointer; color: #6b7280; font-size: 14px; line-height: 1; padding: 0 3px; border-radius: 4px; }
//   .lf-chip-arrow:hover:not(:disabled) { background: #ede7f6; color: #673AB7; }
//   .lf-chip-arrow:disabled { opacity: .25; cursor: default; }
//   .lf-hint { font-size: 11.5px; color: #8a92a3; margin: 8px 0 0; }
//   .lf-funnel { display: flex; flex-direction: column; gap: 6px; }
//   .lf-funnel-row { display: grid; grid-template-columns: 150px 1fr 56px; align-items: center; gap: 10px; padding: 2px 0; border-radius: 6px; transition: background .12s; }
//   .lf-funnel-row:hover { background: #f7f8fc; }
//   .lf-funnel-label { font-size: 12.5px; font-weight: 600; text-align: right; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
//   .lf-funnel-track { display: flex; justify-content: center; }
//   .lf-funnel-bar { height: 32px; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 700; font-size: 13px; min-width: 40px; transition: width .35s ease; box-shadow: 0 1px 2px rgba(0,0,0,.12); }
//   .lf-funnel-pct { font-size: 12px; color: #6b7280; }
//   .lf-pyramid { width: 100%; max-width: 720px; display: block; margin: 0 auto; }
//   .lf-pyramid .layer { transition: opacity .12s; cursor: default; }
//   .lf-pyramid:hover .layer { opacity: .55; }
//   .lf-pyramid .layer:hover { opacity: 1; }
//   .lf-chart-box { position: relative; width: 100%; }
//   .lf-donut-center { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; pointer-events: none; }
//   .lf-donut-center b { display: block; font-size: 26px; }
//   .lf-donut-center span { font-size: 11px; color: #6b7280; text-transform: uppercase; letter-spacing: .5px; }
//   .lf-donut-wrap { display: flex; align-items: center; gap: 24px; flex-wrap: wrap; }
//   .lf-donut-chart { position: relative; flex: 1 1 280px; height: 340px; min-width: 0; }
//   .lf-donut-legend { list-style: none; margin: 0; padding: 0; flex: 1 1 260px; max-height: 340px; overflow-y: auto; display: flex; flex-direction: column; gap: 4px; }
//   .lf-donut-legend li { display: grid; grid-template-columns: 14px 1fr auto 56px; align-items: center; gap: 10px; padding: 6px 8px; border-radius: 6px; font-size: 13px; }
//   .lf-donut-legend li:hover { background: #f7f8fc; }
//   .lf-donut-dot { width: 12px; height: 12px; border-radius: 3px; }
//   .lf-donut-name { font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
//   .lf-donut-count { font-weight: 700; font-variant-numeric: tabular-nums; }
//   .lf-donut-pct { color: #6b7280; font-size: 12px; text-align: right; }
//   .lf-table-wrap { overflow-x: auto; }
//   .lf-table { width: 100%; border-collapse: collapse; font-size: 13px; }
//   .lf-table th { text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: .5px; color: #6b7280; padding: 8px 10px; border-bottom: 1px solid #e5e9f0; white-space: nowrap; }
//   .lf-table th.sortable { cursor: pointer; }
//   .lf-table th.sortable:hover { color: #673AB7; }
//   .lf-table td { padding: 10px; border-bottom: 1px solid #f0f2f7; vertical-align: middle; }
//   .lf-table tr.row:hover td { background: #faf8ff; }
//   .lf-name { font-weight: 700; }
//   .lf-role { display: inline-block; margin-left: 8px; font-size: 10.5px; font-weight: 700; padding: 2px 8px; border-radius: 999px; background: #ede7f6; color: #5b32a3; text-transform: uppercase; letter-spacing: .4px; }
//   .lf-num { font-variant-numeric: tabular-nums; font-weight: 700; }
//   .lf-mix { display: flex; height: 10px; border-radius: 5px; overflow: hidden; background: #eef0f5; min-width: 160px; }
//   .lf-mix span { display: block; height: 100%; }
//   .lf-attn { border: 1px solid #fcd34d; background: #fffbeb; color: #b45309; font-weight: 700; border-radius: 999px; padding: 3px 11px; font-size: 12px; cursor: pointer; }
//   .lf-attn:hover { background: #fef3c7; }
//   .lf-attn.zero { border-color: #e5e9f0; background: #f7f8fc; color: #9aa1af; cursor: default; }
//   .lf-open { border: none; background: none; color: #673AB7; font-weight: 700; cursor: pointer; font-size: 12.5px; padding: 4px 8px; border-radius: 6px; }
//   .lf-open:hover { background: #ede7f6; }
//   .lf-empty { text-align: center; color: #8a92a3; padding: 36px 12px; font-size: 14px; }
//   .lf-error { text-align: center; padding: 48px 12px; color: #b91c1c; }
//   .lf-skel { background: linear-gradient(90deg, #eef0f5 25%, #f7f8fc 50%, #eef0f5 75%); background-size: 200% 100%; animation: lf-shimmer 1.2s infinite; border-radius: 10px; }
//   @keyframes lf-shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
//   .lf-dim { opacity: .55; pointer-events: none; transition: opacity .15s; }
//   .lf-more { text-align: center; margin-top: 12px; }
//   .lf-save { font-size: 12px; color: #6b7280; min-width: 70px; }
//   .lf-overlay { position: fixed; inset: 0; background: rgba(17,24,39,.4); z-index: 50; display: flex; justify-content: flex-end; }
//   .lf-drawer { background: #fff; width: min(560px, 100%); height: 100%; display: flex; flex-direction: column; box-shadow: -8px 0 30px rgba(0,0,0,.15); }
//   .lf-drawer-head { padding: 16px 20px; border-bottom: 1px solid #e5e9f0; display: flex; justify-content: space-between; align-items: center; gap: 10px; }
//   .lf-drawer-head h3 { margin: 0; font-size: 16px; }
//   .lf-drawer-body { padding: 14px 20px 24px; overflow-y: auto; flex: 1; }
//   .lf-lead { border: 1px solid #e5e9f0; border-radius: 10px; padding: 11px 13px; margin-bottom: 10px; }
//   .lf-lead-top { display: flex; justify-content: space-between; gap: 8px; align-items: center; }
//   .lf-lead-name { font-weight: 700; }
//   .lf-lead-meta { font-size: 12px; color: #6b7280; margin-top: 4px; display: flex; flex-wrap: wrap; gap: 4px 14px; }
//   .lf-pill { font-size: 11px; font-weight: 700; padding: 2px 9px; border-radius: 999px; color: #fff; white-space: nowrap; }
//   .lf-days { font-size: 12px; font-weight: 700; color: #b45309; background: #fffbeb; border: 1px solid #fcd34d; border-radius: 999px; padding: 2px 9px; white-space: nowrap; }
//   @media (max-width: 760px) {
//     .lf-top { padding: 12px 14px; }
//     .lf-body { padding: 14px 14px 0; }
//     .lf-funnel-row { grid-template-columns: 90px 1fr 46px; }
//   }
// `;

// const StatusChips = ({ items, hidden, colorOf, onReorder, onToggle }) => {
//   const [dragFrom, setDragFrom] = useState(null);
//   const [over, setOver] = useState(null);

//   const move = (from, to) => {
//     if (from === null || to === null || from === to) return;
//     if (to < 0 || to >= items.length) return;
//     const next = items.slice();
//     const [moved] = next.splice(from, 1);
//     next.splice(to, 0, moved);
//     onReorder(next);
//   };

//   return (
//     <div className="lf-chips">
//       {items.map((s, i) => (
//         <div
//           key={s}
//           draggable
//           className={`lf-chip ${hidden.has(s) ? "hidden" : ""} ${dragFrom === i ? "drag" : ""} ${over === i && dragFrom !== i ? "over" : ""}`}
//           onDragStart={(e) => {
//             setDragFrom(i);
//             e.dataTransfer.effectAllowed = "move";
//             e.dataTransfer.setData("text/plain", s);
//           }}
//           onDragOver={(e) => {
//             e.preventDefault();
//             setOver(i);
//           }}
//           onDragLeave={() => setOver((cur) => (cur === i ? null : cur))}
//           onDrop={(e) => {
//             e.preventDefault();
//             move(dragFrom, i);
//             setDragFrom(null);
//             setOver(null);
//           }}
//           onDragEnd={() => {
//             setDragFrom(null);
//             setOver(null);
//           }}
//         >
//           <span className="lf-chip-grip" aria-hidden="true">
//             ⋮⋮
//           </span>
//           <button
//             type="button"
//             className="lf-chip-arrow"
//             aria-label={`Move ${s} earlier`}
//             disabled={i === 0}
//             onClick={() => move(i, i - 1)}
//           >
//             ‹
//           </button>
//           <span className="lf-chip-dot" style={{ background: colorOf(s) }} />
//           <button
//             type="button"
//             className="lf-chip-name"
//             title={hidden.has(s) ? "Click to show" : "Click to hide"}
//             onClick={() => onToggle(s)}
//           >
//             {s}
//           </button>
//           <button
//             type="button"
//             className="lf-chip-arrow"
//             aria-label={`Move ${s} later`}
//             disabled={i === items.length - 1}
//             onClick={() => move(i, i + 1)}
//           >
//             ›
//           </button>
//         </div>
//       ))}
//     </div>
//   );
// };

// const FunnelChart = ({ rows, total, colorOf }) => {
//   const max = Math.max(1, ...rows.map((r) => r.count));
//   return (
//     <div className="lf-funnel" role="list">
//       {rows.map((r) => {
//         const width = Math.max(6, (r.count / max) * 100);
//         return (
//           <div
//             key={r.status}
//             className="lf-funnel-row"
//             role="listitem"
//             title={`${r.status}: ${fmt(r.count)} leads (${pctOf(r.count, total).toFixed(1)}% of total)`}
//           >
//             <div className="lf-funnel-label">{r.status}</div>
//             <div className="lf-funnel-track">
//               <div
//                 className="lf-funnel-bar"
//                 style={{ width: `${width}%`, background: colorOf(r.status) }}
//               >
//                 {fmt(r.count)}
//               </div>
//             </div>
//             <div className="lf-funnel-pct">
//               {pctOf(r.count, total).toFixed(1)}%
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// const PyramidChart = ({ rows, total, colorOf }) => {
//   const W = 700;
//   const H = 400;
//   const top = 12;
//   const bottom = H - 12;
//   const pad = 16;
//   const cx = W / 2 - 40;
//   const usable = bottom - top;
//   const sum = rows.reduce((a, r) => a + r.count, 0) || 1;
//   const raw = rows.map((r) => Math.max(0.055, r.count / sum));
//   const rawSum = raw.reduce((a, b) => a + b, 0);
//   const heights = raw.map((h) => (h / rawSum) * usable);
//   const halfAt = (y) => ((y - top) / usable) * (cx - pad);

//   let y = top;
//   const layers = rows.map((r, i) => {
//     const y0 = y;
//     const y1 = y + heights[i];
//     y = y1;
//     const a = halfAt(y0);
//     const b = halfAt(y1 - 1);
//     const label = `${r.status} · ${fmt(r.count)}`;
//     const est = label.length * 6.6;
//     const midHalf = (halfAt(y0) + halfAt(y1)) / 2;
//     let inside = midHalf * 2 - 18 >= est && heights[i] >= 18;
//     const outsideFits = cx + midHalf + 10 + est <= W - 4;
//     if (!inside && !outsideFits) inside = true;
//     return {
//       key: r.status,
//       points: `${cx - a},${y0} ${cx + a},${y0} ${cx + b},${y1 - 1} ${cx - b},${y1 - 1}`,
//       mid: (y0 + y1) / 2,
//       midHalf,
//       label,
//       inside,
//       color: colorOf(r.status),
//       tip: `${r.status}: ${fmt(r.count)} leads (${pctOf(r.count, total).toFixed(1)}% of total)`,
//     };
//   });

//   return (
//     <svg
//       className="lf-pyramid"
//       viewBox={`0 0 ${W} ${H}`}
//       role="img"
//       aria-label="Lead pyramid by status"
//     >
//       {layers.map((l) => (
//         <g key={l.key} className="layer">
//           <title>{l.tip}</title>
//           <polygon points={l.points} fill={l.color} />
//           <text
//             x={l.inside ? cx : cx + l.midHalf + 10}
//             y={l.mid + 4}
//             textAnchor={l.inside ? "middle" : "start"}
//             fontSize="12"
//             fontWeight="700"
//             fill={l.inside ? "#fff" : "#1a1f36"}
//           >
//             {l.label}
//           </text>
//         </g>
//       ))}
//     </svg>
//   );
// };

// const SingleChart = ({ type, rows, total, colorOf }) => {
//   const labels = rows.map((r) => r.status);
//   const values = rows.map((r) => r.count);
//   const colors = rows.map((r) => colorOf(r.status));

//   const tooltipLabel = (ctx) => {
//     const v = ctx.parsed.y ?? ctx.parsed.x ?? ctx.parsed;
//     return ` ${fmt(v)} leads (${pctOf(v, total).toFixed(1)}%)`;
//   };

//   if (type === "funnel")
//     return <FunnelChart rows={rows} total={total} colorOf={colorOf} />;
//   if (type === "pyramid")
//     return <PyramidChart rows={rows} total={total} colorOf={colorOf} />;

//   if (type === "bar") {
//     return (
//       <div
//         className="lf-chart-box"
//         style={{ height: Math.max(220, rows.length * 36 + 50) }}
//       >
//         <Bar
//           data={{
//             labels,
//             datasets: [
//               {
//                 data: values,
//                 backgroundColor: colors,
//                 borderRadius: 6,
//                 maxBarThickness: 26,
//               },
//             ],
//           }}
//           options={{
//             indexAxis: "y",
//             responsive: true,
//             maintainAspectRatio: false,
//             plugins: {
//               legend: { display: false },
//               tooltip: { callbacks: { label: tooltipLabel } },
//             },
//             scales: {
//               x: { beginAtZero: true, grid: { color: "#f0f2f7" } },
//               y: { grid: { display: false } },
//             },
//           }}
//         />
//       </div>
//     );
//   }

//   if (type === "line") {
//     return (
//       <div className="lf-chart-box" style={{ height: 340 }}>
//         <Line
//           data={{
//             labels,
//             datasets: [
//               {
//                 data: values,
//                 borderColor: "#673AB7",
//                 backgroundColor: "rgba(103,58,183,0.14)",
//                 pointBackgroundColor: colors,
//                 pointBorderColor: "#fff",
//                 pointRadius: 6,
//                 pointHoverRadius: 8,
//                 borderWidth: 2.5,
//                 tension: 0.3,
//                 fill: true,
//               },
//             ],
//           }}
//           options={{
//             responsive: true,
//             maintainAspectRatio: false,
//             plugins: {
//               legend: { display: false },
//               tooltip: { callbacks: { label: tooltipLabel } },
//             },
//             scales: {
//               y: { beginAtZero: true, grid: { color: "#f0f2f7" } },
//               x: { grid: { display: false } },
//             },
//           }}
//         />
//       </div>
//     );
//   }

//   return (
//     <div className="lf-donut-wrap">
//       <div className="lf-donut-chart">
//         <Doughnut
//           data={{
//             labels,
//             datasets: [
//               { data: values, backgroundColor: colors, borderWidth: 2 },
//             ],
//           }}
//           options={{
//             responsive: true,
//             maintainAspectRatio: false,
//             cutout: "62%",
//             plugins: {
//               legend: { display: false },
//               tooltip: { callbacks: { label: tooltipLabel } },
//             },
//           }}
//         />
//         <div className="lf-donut-center">
//           <b>{fmt(total)}</b>
//           <span>Leads</span>
//         </div>
//       </div>

//       <ul className="lf-donut-legend">
//         {rows.map((r) => (
//           <li key={r.status} title={`${r.status}: ${fmt(r.count)} leads`}>
//             <span
//               className="lf-donut-dot"
//               style={{ background: colorOf(r.status) }}
//             />
//             <span className="lf-donut-name">{r.status}</span>
//             <span className="lf-donut-count">{fmt(r.count)}</span>
//             <span className="lf-donut-pct">
//               {pctOf(r.count, total).toFixed(1)}%
//             </span>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// const CompareChart = ({ nodes, statuses, colorOf, mode, onDrill }) => {
//   const maps = useMemo(() => nodes.map((n) => toCountMap(n.statuses)), [nodes]);
//   const labels = nodes.map((n) => n.name);

//   const datasets = statuses.map((s) => ({
//     label: s,
//     backgroundColor: colorOf(s),
//     borderColor: colorOf(s),
//     borderWidth: mode === "lines" ? 2.5 : 0,
//     borderRadius: mode === "lines" ? 0 : 3,
//     tension: 0.25,
//     pointRadius: mode === "lines" ? 3 : 0,
//     fill: false,
//     data: nodes.map((n, i) => {
//       const v = maps[i][s] || 0;
//       return mode === "share" ? +pctOf(v, n.totalLeads).toFixed(1) : v;
//     }),
//   }));

//   const handleClick = (_evt, elements) => {
//     if (!elements || !elements.length) return;
//     const node = nodes[elements[0].index];
//     if (node && node.drillable) onDrill(node);
//   };

//   const common = {
//     responsive: true,
//     maintainAspectRatio: false,
//     onClick: handleClick,
//     interaction: { mode: "nearest", intersect: true },
//     plugins: {
//       legend: { position: "bottom", labels: { boxWidth: 12 } },
//       tooltip: {
//         callbacks: {
//           label: (ctx) => {
//             const v = ctx.parsed.x ?? ctx.parsed.y;
//             return mode === "share"
//               ? ` ${ctx.dataset.label}: ${v}%`
//               : ` ${ctx.dataset.label}: ${fmt(v)}`;
//           },
//         },
//       },
//     },
//   };

//   if (mode === "lines") {
//     return (
//       <div className="lf-chart-box" style={{ height: 380 }}>
//         <Line
//           data={{ labels, datasets }}
//           options={{
//             ...common,
//             scales: {
//               y: { beginAtZero: true, grid: { color: "#f0f2f7" } },
//               x: { grid: { display: false } },
//             },
//           }}
//         />
//       </div>
//     );
//   }

//   const stacked = mode === "stacked" || mode === "share";
//   const perNode = stacked ? 30 : Math.max(30, statuses.length * 11 + 12);
//   return (
//     <div
//       className="lf-chart-box"
//       style={{ height: Math.max(280, nodes.length * perNode + 110) }}
//     >
//       <Bar
//         data={{ labels, datasets }}
//         options={{
//           ...common,
//           indexAxis: "y",
//           scales: {
//             x: {
//               stacked,
//               beginAtZero: true,
//               max: mode === "share" ? 100 : undefined,
//               grid: { color: "#f0f2f7" },
//               ticks: mode === "share" ? { callback: (v) => `${v}%` } : {},
//             },
//             y: { stacked, grid: { display: false } },
//           },
//         }}
//       />
//     </div>
//   );
// };

// const MixBar = ({ node, order, colorOf }) => {
//   const map = toCountMap(node.statuses);
//   return (
//     <div className="lf-mix">
//       {order
//         .filter((s) => map[s] > 0)
//         .map((s) => (
//           <span
//             key={s}
//             title={`${s}: ${fmt(map[s])}`}
//             style={{
//               width: `${pctOf(map[s], node.totalLeads)}%`,
//               background: colorOf(s),
//             }}
//           />
//         ))}
//     </div>
//   );
// };

// const AttentionDrawer = ({ state, onClose, onMore, colorOf }) => {
//   if (!state.open) return null;
//   return (
//     <div className="lf-overlay" onClick={onClose}>
//       <div
//         className="lf-drawer"
//         role="dialog"
//         aria-modal="true"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="lf-drawer-head">
//           <h3>{state.title}</h3>
//           <button type="button" className="lf-btn" onClick={onClose}>
//             Close
//           </button>
//         </div>
//         <div className="lf-drawer-body">
//           {state.error && (
//             <div className="lf-error">Could not load these leads.</div>
//           )}
//           {!state.error && !state.loading && state.items.length === 0 && (
//             <div className="lf-empty">
//               Nothing needs attention here. Nice work.
//             </div>
//           )}
//           {state.items.map((l) => (
//             <div className="lf-lead" key={l.leadId}>
//               <div className="lf-lead-top">
//                 <span className="lf-lead-name">{l.name || "Unnamed lead"}</span>
//                 <span className="lf-days">{l.daysInStatus}d in status</span>
//               </div>
//               <div className="lf-lead-meta">
//                 <span
//                   className="lf-pill"
//                   style={{ background: colorOf(l.status || "") }}
//                 >
//                   {l.status || "Unknown"}
//                 </span>
//                 {l.phone && <span>{l.phone}</span>}
//                 <span>{l.executiveName || "Unassigned"}</span>
//                 {l.projectName && <span>{l.projectName}</span>}
//                 <span>Last interaction: {daysLabel(l.daysSinceLastInteraction)}</span>
//               </div>
//             </div>
//           ))}
//           {state.loading && (
//             <div className="lf-skel" style={{ height: 70, marginBottom: 10 }} />
//           )}
//           {state.hasNext && !state.loading && (
//             <div className="lf-more">
//               <button type="button" className="lf-btn" onClick={onMore}>
//                 Load more
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const LeadFunnel = () => {
//   const navigate = useNavigate();
//   const { user } = useContext(AuthContext);
//   const userId = user?.id;

//   const [nodeId, setNodeId] = useState(null);
//   const [view, setView] = useState("overview");
//   const [level, setLevel] = useState("DIRECT");
//   const [chartType, setChartType] = useState("funnel");
//   const [compareMode, setCompareMode] = useState("stacked");
//   const [showEmpty, setShowEmpty] = useState(false);
//   const [hidden, setHidden] = useState(() => new Set());
//   const [order, setOrder] = useState([]);
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [saveState, setSaveState] = useState("");
//   const [sort, setSort] = useState({ key: "total", dir: "desc" });
//   const [compareLimit, setCompareLimit] = useState(COMPARE_LIMIT_STEP);
//   const [attn, setAttn] = useState({
//     open: false,
//     title: "",
//     params: {},
//     items: [],
//     page: 0,
//     hasNext: false,
//     loading: false,
//     error: false,
//   });

//   const reqRef = useRef(0);
//   const saveTimer = useRef(null);
//   const attnReq = useRef(0);

//   const levelParam = view === "compare" && level !== "DIRECT" ? level : "";

//   const load = useCallback(
//     async (silent) => {
//       if (!userId) return;
//       const id = ++reqRef.current;
//       if (!silent) setLoading(true);
//       try {
//         const r = await axios.get(
//           `${API_URL}/api/lead-insights/funnel/${userId}`,
//           {
//             headers: authHeader(),
//             params: {
//               nodeId: nodeId || undefined,
//               level: levelParam || undefined,
//             },
//           },
//         );
//         if (id !== reqRef.current) return;
//         setData(r.data);
//         setError(null);
//         setOrder((prev) => mergeOrder(prev, r.data.statusList));
//       } catch (e) {
//         if (id !== reqRef.current) return;
//         setError(e.response?.status === 403 ? "forbidden" : "failed");
//       } finally {
//         if (id === reqRef.current) setLoading(false);
//       }
//     },
//     [userId, nodeId, levelParam],
//   );

//   useEffect(() => {
//     load(false);
//   }, [load]);

//   useEffect(() => {
//     const t = setInterval(() => {
//       if (!document.hidden) load(true);
//     }, 60000);
//     return () => clearInterval(t);
//   }, [load]);

//   useEffect(() => {
//     if (!userId) return;
//     axios
//       .get(`${API_URL}/api/lead-insights/funnel-preferences/${userId}`, {
//         headers: authHeader(),
//       })
//       .then((r) => {
//         const saved = r.data?.statusOrder || [];
//         setOrder((prev) => mergeOrder(saved, prev));
//         if (SINGLE_CHARTS.some((c) => c.key === r.data?.chartType)) {
//           setChartType(r.data.chartType);
//         }
//       })
//       .catch(() => {});
//   }, [userId]);

//   useEffect(() => () => clearTimeout(saveTimer.current), []);

//   const savePrefs = useCallback(
//     (body, delay) => {
//       if (!userId) return;
//       clearTimeout(saveTimer.current);
//       setSaveState("Saving…");
//       saveTimer.current = setTimeout(() => {
//         axios
//           .put(
//             `${API_URL}/api/lead-insights/funnel-preferences/${userId}`,
//             body,
//             { headers: authHeader() },
//           )
//           .then(() => setSaveState("Saved"))
//           .catch(() => setSaveState("Could not save"));
//       }, delay);
//     },
//     [userId],
//   );

//   const present = useMemo(() => data?.statusList || [], [data]);

//   const orderedPresent = useMemo(
//     () => order.filter((s) => present.includes(s)),
//     [order, present],
//   );

//   const colorOf = useMemo(() => {
//     const names = [...new Set([...order, ...present])].sort((a, b) =>
//       a.localeCompare(b),
//     );
//     const index = new Map(names.map((n, i) => [n, i]));
//     return (s) => PALETTE[(index.get(s) ?? 0) % PALETTE.length];
//   }, [order, present]);

//   const onReorder = (nextPresent) => {
//     const nextFull = applyPresentOrder(order, orderedPresent, nextPresent);
//     setOrder(nextFull);
//     savePrefs({ statusOrder: nextFull }, 500);
//   };

//   const onToggleStatus = (s) =>
//     setHidden((prev) => {
//       const next = new Set(prev);
//       if (next.has(s)) next.delete(s);
//       else next.add(s);
//       return next;
//     });

//   const onChartType = (key) => {
//     setChartType(key);
//     savePrefs({ chartType: key }, 0);
//   };

//   const drill = (entry) => {
//     if (!entry || !entry.drillable) return;
//     setNodeId(entry.id);
//     setView("overview");
//     setLevel("DIRECT");
//     setCompareLimit(COMPARE_LIMIT_STEP);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const totalLeads = data?.total?.totalLeads || 0;
//   const totalMap = useMemo(() => toCountMap(data?.total?.statuses), [data]);

//   const singleRows = useMemo(
//     () =>
//       orderedPresent
//         .filter((s) => !hidden.has(s))
//         .map((s) => ({ status: s, count: totalMap[s] || 0 }))
//         .filter((r) => showEmpty || r.count > 0),
//     [orderedPresent, hidden, totalMap, showEmpty],
//   );

//   const levelReady =
//     level === "DIRECT" || (data?.levelRole || "").toUpperCase() === level;

//   const compareNodes = useMemo(() => {
//     if (view !== "compare" || !data || !levelReady) return [];
//     const list = level === "DIRECT" ? data.children : data.levelNodes;
//     return (list || []).filter((n) => n.totalLeads > 0 || showEmpty);
//   }, [view, data, level, levelReady, showEmpty]);

//   const shownCompareNodes = useMemo(
//     () => compareNodes.slice(0, compareLimit),
//     [compareNodes, compareLimit],
//   );

//   const compareStatuses = useMemo(() => {
//     const maps = shownCompareNodes.map((n) => toCountMap(n.statuses));
//     return orderedPresent
//       .filter((s) => !hidden.has(s))
//       .filter((s) => showEmpty || maps.some((m) => (m[s] || 0) > 0));
//   }, [shownCompareNodes, orderedPresent, hidden, showEmpty]);

//   const tableRows = useMemo(() => {
//     const rows = (data?.children || []).slice();
//     const dir = sort.dir === "asc" ? 1 : -1;
//     rows.sort((a, b) => {
//       if (sort.key === "name") return dir * a.name.localeCompare(b.name);
//       if (sort.key === "attention") return dir * (a.attention - b.attention);
//       return dir * (a.totalLeads - b.totalLeads);
//     });
//     return rows;
//   }, [data, sort]);

//   const toggleSort = (key) =>
//     setSort((cur) =>
//       cur.key === key
//         ? { key, dir: cur.dir === "asc" ? "desc" : "asc" }
//         : { key, dir: key === "name" ? "asc" : "desc" },
//     );

//   const sortMark = (key) =>
//     sort.key === key ? (sort.dir === "asc" ? " ▲" : " ▼") : "";

//   const fetchAttention = useCallback(
//     async (params, page, replace) => {
//       const id = ++attnReq.current;
//       setAttn((cur) => ({ ...cur, loading: true, error: false }));
//       try {
//         const r = await axios.get(
//           `${API_URL}/api/lead-insights/needs-attention/${userId}`,
//           { headers: authHeader(), params: { page, size: 25, ...params } },
//         );
//         if (id !== attnReq.current) return;
//         setAttn((cur) => ({
//           ...cur,
//           loading: false,
//           page,
//           hasNext: !!r.data.hasNext,
//           items: replace ? r.data.items : [...cur.items, ...r.data.items],
//         }));
//       } catch (e) {
//         if (id !== attnReq.current) return;
//         setAttn((cur) => ({ ...cur, loading: false, error: true }));
//       }
//     },
//     [userId],
//   );

//   const openAttention = (entry) => {
//     if (!entry || entry.listable === false) return;
//     const params =
//       entry.id === "UNASSIGNED"
//         ? { executiveId: "UNASSIGNED" }
//         : { nodeId: entry.id };
//     setAttn({
//       open: true,
//       title: `${entry.name} · needs attention`,
//       params,
//       items: [],
//       page: 0,
//       hasNext: false,
//       loading: true,
//       error: false,
//     });
//     fetchAttention(params, 0, true);
//   };

//   const closeAttention = () => {
//     attnReq.current += 1;
//     setAttn((cur) => ({ ...cur, open: false }));
//   };

//   if (error === "forbidden") {
//     return (
//       <>
//         <style>{LF_CSS}</style>
//         <div className="lf-root">
//           <div className="lf-error">
//             You do not have access to Leads, so the funnel is unavailable.
//           </div>
//         </div>
//       </>
//     );
//   }

//   const node = data?.node;
//   const attention = data?.total?.attention || 0;
//   const ownLeads = data?.own?.totalLeads || 0;
//   const hasChildren = (data?.children || []).length > 0;

//   return (
//     <>
//       <style>{LF_CSS}</style>
//       <div className="lf-root">
//         <div className="lf-top">
//           <div>
//             <h1 className="lf-title">Lead Funnel</h1>
//             <p className="lf-sub">
//               {data
//                 ? `Updated ${new Date(data.generatedAt).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })} · attention = no status change for ${data.staleAfterDays}+ days`
//                 : "Loading…"}
//             </p>
//           </div>
//           <div className="lf-actions">
//             <span className="lf-save">{saveState}</span>
//             <button
//               type="button"
//               className="lf-btn"
//               onClick={() => load(false)}
//               disabled={loading}
//             >
//               Refresh
//             </button>
//             <button
//               type="button"
//               className="lf-btn primary"
//               onClick={() => navigate("/dashboard")}
//             >
//               ← Dashboard
//             </button>
//           </div>
//         </div>

//         <div className="lf-body">
//           {error === "failed" && !data && (
//             <div className="lf-error">
//               Could not load the funnel.{" "}
//               <button type="button" className="lf-btn" onClick={() => load(false)}>
//                 Try again
//               </button>
//             </div>
//           )}

//           {!data && !error && (
//             <>
//               <div className="lf-skel" style={{ height: 90 }} />
//               <div className="lf-skel" style={{ height: 380 }} />
//             </>
//           )}

//           {data && (
//             <div className={loading ? "lf-dim" : ""} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
//               <div className="lf-crumbs">
//                 {(data.breadcrumb || []).map((c, i, arr) => {
//                   const last = i === arr.length - 1;
//                   return (
//                     <span key={c.id} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
//                       <button
//                         type="button"
//                         className={`lf-crumb ${last ? "last" : ""}`}
//                         onClick={() => !last && setNodeId(c.id)}
//                       >
//                         {c.name}
//                       </button>
//                       {!last && <span className="lf-crumb-sep">›</span>}
//                     </span>
//                   );
//                 })}
//                 {node && <span className="lf-role">{roleLabel(node.role)}</span>}
//               </div>

//               <div className="lf-kpis">
//                 <div className="lf-kpi">
//                   <div className="lf-kpi-label">Total leads</div>
//                   <div className="lf-kpi-value">{fmt(totalLeads)}</div>
//                   <div className="lf-kpi-sub">
//                     {hasChildren ? "Including everyone below" : "Assigned to this person"}
//                   </div>
//                 </div>
//                 <button
//                   type="button"
//                   className="lf-kpi warn"
//                   onClick={() => openAttention(node)}
//                   disabled={attention === 0}
//                 >
//                   <div className="lf-kpi-label">Needs attention</div>
//                   <div className="lf-kpi-value">{fmt(attention)}</div>
//                   <div className="lf-kpi-sub">
//                     {pctOf(attention, totalLeads).toFixed(1)}% of leads · click to view
//                   </div>
//                 </button>
//                 <div className="lf-kpi">
//                   <div className="lf-kpi-label">Statuses in play</div>
//                   <div className="lf-kpi-value">{fmt(singleRows.filter((r) => r.count > 0).length)}</div>
//                   <div className="lf-kpi-sub">With at least one lead</div>
//                 </div>
//                 {hasChildren && (
//                   <div className="lf-kpi">
//                     <div className="lf-kpi-label">Held directly</div>
//                     <div className="lf-kpi-value">{fmt(ownLeads)}</div>
//                     <div className="lf-kpi-sub">
//                       Leads assigned to {node?.name || "this person"} themselves
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div className="lf-card">
//                 <div className="lf-card-head">
//                   <h2 className="lf-card-title">Status order</h2>
//                   <label className="lf-check">
//                     <input
//                       type="checkbox"
//                       checked={showEmpty}
//                       onChange={(e) => setShowEmpty(e.target.checked)}
//                     />
//                     Show empty statuses
//                   </label>
//                 </div>
//                 <StatusChips
//                   items={orderedPresent}
//                   hidden={hidden}
//                   colorOf={colorOf}
//                   onReorder={onReorder}
//                   onToggle={onToggleStatus}
//                 />
//                 <p className="lf-hint">
//                   Drag a status (or use the arrows) to set the order. It is saved for you. Click a name to hide or show it.
//                 </p>
//               </div>

//               <div className="lf-card">
//                 <div className="lf-card-head">
//                   <div className="lf-seg" role="group" aria-label="View">
//                     <button
//                       type="button"
//                       className={view === "overview" ? "on" : ""}
//                       aria-pressed={view === "overview"}
//                       onClick={() => setView("overview")}
//                     >
//                       {node?.name ? `${node.name}` : "Overview"}
//                     </button>
//                     <button
//                       type="button"
//                       className={view === "compare" ? "on" : ""}
//                       aria-pressed={view === "compare"}
//                       onClick={() => setView("compare")}
//                     >
//                       Compare side by side
//                     </button>
//                   </div>

//                   <div className="lf-toolbar">
//                     {view === "compare" && (
//                       <select
//                         className="lf-select"
//                         value={level}
//                         onChange={(e) => {
//                           setLevel(e.target.value);
//                           setCompareLimit(COMPARE_LIMIT_STEP);
//                         }}
//                         aria-label="Compare level"
//                       >
//                         {LEVELS.map((l) => (
//                           <option key={l.key} value={l.key}>
//                             {l.label}
//                           </option>
//                         ))}
//                       </select>
//                     )}
//                     <div className="lf-seg" role="group" aria-label="Chart type">
//                       {(view === "compare" ? COMPARE_CHARTS : SINGLE_CHARTS).map((c) => {
//                         const active = view === "compare" ? compareMode === c.key : chartType === c.key;
//                         return (
//                           <button
//                             key={c.key}
//                             type="button"
//                             className={active ? "on" : ""}
//                             aria-pressed={active}
//                             onClick={() =>
//                               view === "compare" ? setCompareMode(c.key) : onChartType(c.key)
//                             }
//                           >
//                             {c.label}
//                           </button>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 </div>

//                 {view === "overview" && (
//                   <>
//                     {singleRows.length === 0 ? (
//                       <div className="lf-empty">No leads to show for this selection yet.</div>
//                     ) : (
//                       <SingleChart
//                         type={chartType}
//                         rows={singleRows}
//                         total={totalLeads}
//                         colorOf={colorOf}
//                       />
//                     )}
//                   </>
//                 )}

//                 {view === "compare" && (
//                   <>
//                     {!levelReady && <div className="lf-skel" style={{ height: 280 }} />}
//                     {levelReady && shownCompareNodes.length === 0 && (
//                       <div className="lf-empty">
//                         No {LEVELS.find((l) => l.key === level)?.label.toLowerCase()} with leads under {node?.name}.
//                       </div>
//                     )}
//                     {levelReady && shownCompareNodes.length > 0 && (
//                       <>
//                         <CompareChart
//                           nodes={shownCompareNodes}
//                           statuses={compareStatuses}
//                           colorOf={colorOf}
//                           mode={compareMode}
//                           onDrill={drill}
//                         />
//                         <p className="lf-hint">Click a bar to open that person's funnel.</p>
//                         {compareNodes.length > shownCompareNodes.length && (
//                           <div className="lf-more">
//                             <button
//                               type="button"
//                               className="lf-btn"
//                               onClick={() => setCompareLimit((n) => n + COMPARE_LIMIT_STEP)}
//                             >
//                               Show more ({compareNodes.length - shownCompareNodes.length} left)
//                             </button>
//                           </div>
//                         )}
//                       </>
//                     )}
//                   </>
//                 )}
//               </div>

//               {hasChildren && (
//                 <div className="lf-card">
//                   <div className="lf-card-head">
//                     <h2 className="lf-card-title">
//                       {node?.role === "COMPANY" ? "Teams and people" : `Reporting to ${node?.name}`}
//                     </h2>
//                   </div>
//                   <div className="lf-table-wrap">
//                     <table className="lf-table">
//                       <thead>
//                         <tr>
//                           <th className="sortable" onClick={() => toggleSort("name")}>
//                             Name{sortMark("name")}
//                           </th>
//                           <th className="sortable" onClick={() => toggleSort("total")}>
//                             Leads{sortMark("total")}
//                           </th>
//                           <th>Status mix</th>
//                           <th className="sortable" onClick={() => toggleSort("attention")}>
//                             Needs attention{sortMark("attention")}
//                           </th>
//                           <th />
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {tableRows.map((row) => (
//                           <tr className="row" key={row.id}>
//                             <td>
//                               <span className="lf-name">{row.name}</span>
//                               <span className="lf-role">{roleLabel(row.role)}</span>
//                             </td>
//                             <td className="lf-num">{fmt(row.totalLeads)}</td>
//                             <td>
//                               <MixBar node={row} order={orderedPresent} colorOf={colorOf} />
//                             </td>
//                             <td>
//                               <button
//                                 type="button"
//                                 className={`lf-attn ${row.attention === 0 || row.listable === false ? "zero" : ""}`}
//                                 disabled={row.attention === 0 || row.listable === false}
//                                 onClick={() => openAttention(row)}
//                               >
//                                 {fmt(row.attention)}
//                               </button>
//                             </td>
//                             <td>
//                               {row.drillable && (
//                                 <button type="button" className="lf-open" onClick={() => drill(row)}>
//                                   Open ›
//                                 </button>
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         <AttentionDrawer
//           state={attn}
//           onClose={closeAttention}
//           onMore={() => fetchAttention(attn.params, attn.page + 1, false)}
//           colorOf={colorOf}
//         />
//       </div>
//     </>
//   );
// };

// export default LeadFunnel;













import {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Bar, Line, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Filler,
  Title,
} from "chart.js";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Filler,
  Title,
);

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const PALETTE = [
  "#673AB7",
  "#2196F3",
  "#00A896",
  "#F59E0B",
  "#EF4444",
  "#8B5CF6",
  "#10B981",
  "#EC4899",
  "#3B82F6",
  "#F97316",
  "#14B8A6",
  "#6366F1",
];

const SINGLE_CHARTS = [
  { key: "funnel", label: "Funnel" },
  { key: "pyramid", label: "Pyramid" },
  { key: "bar", label: "Bar" },
  { key: "line", label: "Graph" },
  { key: "doughnut", label: "Donut" },
];

const COMPARE_CHARTS = [
  { key: "stacked", label: "Stacked" },
  { key: "grouped", label: "Grouped" },
  { key: "share", label: "Share %" },
  { key: "lines", label: "Lines" },
];

const LEVELS = [
  { key: "DIRECT", label: "Direct reports" },
  { key: "VICE_PRESIDENT", label: "Vice presidents" },
  { key: "MANAGER", label: "Managers" },
  { key: "TEAM_LEAD", label: "Team leads" },
  { key: "EXECUTIVE", label: "Executives" },
];

const ROLE_LABEL = {
  COMPANY: "Company",
  VICE_PRESIDENT: "VP",
  MANAGER: "Manager",
  TEAM_LEAD: "Team lead",
  EXECUTIVE: "Executive",
  HR: "HR",
  UNASSIGNED: "Unassigned",
  OTHER: "Other",
};

const COMPARE_LIMIT_STEP = 25;

const fmt = (n) => Number(n || 0).toLocaleString("en-IN");

const pctOf = (a, b) => (b ? (a / b) * 100 : 0);

const roleLabel = (r) => {
  const key = String(r || "").toUpperCase();
  if (ROLE_LABEL[key]) return ROLE_LABEL[key];
  const text = key.replace(/_/g, " ").toLowerCase();
  return text ? text.replace(/^./, (c) => c.toUpperCase()) : "Member";
};

export const mergeOrder = (saved, statusList) => {
  const seen = new Set();
  const out = [];
  [...(saved || []), ...(statusList || [])].forEach((s) => {
    if (s && !seen.has(s)) {
      seen.add(s);
      out.push(s);
    }
  });
  return out;
};

export const applyPresentOrder = (full, present, nextPresent) => {
  const presentSet = new Set(present);
  let i = 0;
  return full.map((s) => (presentSet.has(s) ? nextPresent[i++] : s));
};

const toCountMap = (statuses) =>
  (statuses || []).reduce((acc, row) => {
    acc[row.status] = row.count;
    return acc;
  }, {});

const daysLabel = (d) => {
  if (d === null || d === undefined) return "No interaction yet";
  if (d === 0) return "Today";
  return `${d} day${d === 1 ? "" : "s"} ago`;
};

const LF_CSS = `
  .lf-root {
    min-height: 100vh;
    background: #f5f6fa;
    color: #0f172a;
    font-family: "Inter", "Segoe UI", "SF Pro Text", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    padding-bottom: 56px;
  }
  .lf-root * { box-sizing: border-box; }

  /* ---------- Top bar ---------- */
  .lf-top {
    background: rgba(255,255,255,.92);
    backdrop-filter: saturate(180%) blur(12px);
    border-bottom: 1px solid #e2e6ef;
    padding: 18px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    position: sticky;
    top: 0;
    z-index: 10;
    flex-wrap: wrap;
  }
  .lf-title {
    font-size: 22px;
    font-weight: 800;
    color: #5b32a3;
    margin: 0;
    letter-spacing: -0.5px;
    line-height: 1.2;
  }
  .lf-sub {
    font-size: 13px;
    color: #4b5563;
    margin: 4px 0 0;
    font-weight: 500;
    letter-spacing: 0.1px;
  }
  .lf-actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }

  /* ---------- Buttons ---------- */
  .lf-btn {
    border: 1px solid #cfd6e2;
    background: #fff;
    color: #1e293b;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 13.5px;
    font-weight: 650;
    font-family: inherit;
    letter-spacing: 0.1px;
    cursor: pointer;
    transition: all .15s ease;
  }
  .lf-btn:hover:not(:disabled) { border-color: #673AB7; color: #5b32a3; background: #faf8ff; }
  .lf-btn:disabled { opacity: .5; cursor: default; }
  .lf-btn.primary {
    background: #673AB7;
    border-color: #673AB7;
    color: #fff;
    box-shadow: 0 1px 3px rgba(103,58,183,.28);
  }
  .lf-btn.primary:hover:not(:disabled) { background: #5b32a3; color: #fff; }

  /* ---------- Body ---------- */
  .lf-body {
    max-width: 1280px;
    margin: 0 auto;
    padding: 24px 32px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  /* ---------- Breadcrumbs ---------- */
  .lf-crumbs { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; font-size: 13.5px; }
  .lf-crumb {
    background: none;
    border: none;
    padding: 3px 6px;
    color: #5b32a3;
    cursor: pointer;
    font-weight: 650;
    font-size: 13.5px;
    font-family: inherit;
    border-radius: 5px;
    transition: background .12s;
  }
  .lf-crumb:hover { background: #ede7f6; }
  .lf-crumb.last { color: #0f172a; cursor: default; font-weight: 750; }
  .lf-crumb.last:hover { background: none; }
  .lf-crumb-sep { color: #94a3b8; font-weight: 600; }

  /* ---------- KPI cards ---------- */
  .lf-kpis { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; }
  .lf-kpi {
    background: #fff;
    border: 1px solid #e2e6ef;
    border-radius: 12px;
    padding: 16px 18px;
    box-shadow: 0 1px 2px rgba(15,23,42,.04);
    text-align: left;
    font: inherit;
    color: inherit;
    transition: all .15s ease;
  }
  button.lf-kpi { cursor: pointer; }
  button.lf-kpi:hover { border-color: #f59e0b; box-shadow: 0 4px 12px rgba(245,158,11,.18); }
  .lf-kpi-label {
    font-size: 11.5px;
    font-weight: 750;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #64748b;
  }
  .lf-kpi-value {
    font-size: 30px;
    font-weight: 800;
    margin-top: 6px;
    line-height: 1.1;
    color: #0f172a;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.5px;
  }
  .lf-kpi-sub { font-size: 12.5px; color: #64748b; margin-top: 4px; font-weight: 500; }
  .lf-kpi.warn .lf-kpi-value { color: #d97706; }

  /* ---------- Cards ---------- */
  .lf-card {
    background: #fff;
    border: 1px solid #e2e6ef;
    border-radius: 14px;
    padding: 20px;
    box-shadow: 0 1px 2px rgba(15,23,42,.04);
    position: relative;
  }
  .lf-card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 14px;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }
  .lf-card-title {
    font-size: 16px;
    font-weight: 750;
    margin: 0;
    color: #0f172a;
    letter-spacing: -0.2px;
  }

  /* ---------- Segmented control ---------- */
  .lf-seg {
    display: inline-flex;
    background: #eef1f6;
    border-radius: 9px;
    padding: 3px;
    gap: 2px;
    flex-wrap: wrap;
  }
  .lf-seg button {
    border: none;
    background: transparent;
    padding: 7px 14px;
    font-size: 13px;
    font-weight: 650;
    font-family: inherit;
    color: #475569;
    border-radius: 7px;
    cursor: pointer;
    transition: all .12s ease;
    letter-spacing: 0.1px;
  }
  .lf-seg button:hover { color: #5b32a3; }
  .lf-seg button.on {
    background: #fff;
    color: #5b32a3;
    box-shadow: 0 1px 3px rgba(15,23,42,.14);
    font-weight: 750;
  }

  .lf-toolbar { display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }
  .lf-select {
    border: 1px solid #cfd6e2;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 13.5px;
    font-family: inherit;
    font-weight: 550;
    background: #fff;
    color: #1e293b;
    cursor: pointer;
  }
  .lf-check {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 13px;
    font-weight: 550;
    color: #475569;
    cursor: pointer;
    user-select: none;
  }
  .lf-check input { width: 16px; height: 16px; cursor: pointer; accent-color: #673AB7; }

  /* ---------- Status chips ---------- */
  .lf-chips { display: flex; flex-wrap: wrap; gap: 8px; }
  .lf-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #fff;
    border: 1px solid #cfd6e2;
    border-radius: 999px;
    padding: 4px 8px 4px 5px;
    font-size: 13px;
    font-weight: 550;
    cursor: grab;
    user-select: none;
    transition: all .12s ease;
  }
  .lf-chip:hover { border-color: #a78bda; }
  .lf-chip.hidden { opacity: .5; }
  .lf-chip.drag { opacity: .4; }
  .lf-chip.over { border-color: #673AB7; background: #ede7f6; }
  .lf-chip-grip { color: #94a3b8; font-size: 11px; padding: 0 2px; letter-spacing: -2px; }
  .lf-chip-dot { width: 10px; height: 10px; border-radius: 50%; flex: none; box-shadow: 0 0 0 1px rgba(0,0,0,.06); }
  .lf-chip-name {
    background: none;
    border: none;
    font: inherit;
    font-weight: 650;
    cursor: pointer;
    padding: 2px 5px;
    color: #1e293b;
    font-family: inherit;
    font-size: 13px;
  }
  .lf-chip.hidden .lf-chip-name { text-decoration: line-through; color: #64748b; }
  .lf-chip-arrow {
    border: none;
    background: none;
    cursor: pointer;
    color: #64748b;
    font-size: 15px;
    line-height: 1;
    padding: 1px 5px;
    border-radius: 4px;
    font-weight: 700;
    transition: all .12s;
  }
  .lf-chip-arrow:hover:not(:disabled) { background: #ede7f6; color: #5b32a3; }
  .lf-chip-arrow:disabled { opacity: .3; cursor: default; }
  .lf-hint { font-size: 12.5px; color: #64748b; margin: 10px 0 0; font-weight: 500; line-height: 1.5; }

  /* ---------- Funnel ---------- */
  .lf-funnel { display: flex; flex-direction: column; gap: 8px; }
  .lf-funnel-row {
    display: grid;
    grid-template-columns: 160px 1fr 60px;
    align-items: center;
    gap: 12px;
    padding: 3px 0;
    border-radius: 6px;
    transition: background .12s;
  }
  .lf-funnel-row:hover { background: #f8fafc; }
  .lf-funnel-label {
    font-size: 13.5px;
    font-weight: 650;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #1e293b;
  }
  .lf-funnel-track { display: flex; justify-content: center; }
  .lf-funnel-bar {
    height: 34px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 750;
    font-size: 13.5px;
    min-width: 44px;
    transition: width .35s ease;
    box-shadow: 0 1px 3px rgba(0,0,0,.14);
    letter-spacing: 0.2px;
    text-shadow: 0 1px 1px rgba(0,0,0,.15);
  }
  .lf-funnel-pct {
    font-size: 13px;
    color: #475569;
    font-weight: 650;
    font-variant-numeric: tabular-nums;
  }

  /* ---------- Pyramid ---------- */
  .lf-pyramid { width: 100%; max-width: 720px; display: block; margin: 0 auto; }
  .lf-pyramid .layer { transition: opacity .12s; cursor: default; }
  .lf-pyramid:hover .layer { opacity: .55; }
  .lf-pyramid .layer:hover { opacity: 1; }
  .lf-pyramid text { font-family: "Inter", "Segoe UI", -apple-system, sans-serif; }

  /* ---------- Charts ---------- */
  .lf-chart-box { position: relative; width: 100%; }
  .lf-chart-box canvas { font-family: "Inter", "Segoe UI", -apple-system, sans-serif !important; }

  /* ---------- Doughnut ---------- */
  .lf-donut-wrap { display: flex; align-items: flex-start; gap: 32px; flex-wrap: wrap; }
  .lf-donut-chart { position: relative; flex: 0 0 320px; width: 320px; height: 320px; }
  .lf-donut-chart canvas { display: block; }
  .lf-donut-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: none;
    line-height: 1.1;
  }
  .lf-donut-center b {
    display: block;
    font-size: 30px;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.5px;
    font-variant-numeric: tabular-nums;
  }
  .lf-donut-center span {
    font-size: 11.5px;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-weight: 750;
  }
  .lf-donut-legend {
    list-style: none;
    margin: 0;
    padding: 0;
    flex: 1 1 300px;
    min-width: 260px;
    max-height: 320px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .lf-donut-legend li {
    display: grid;
    grid-template-columns: 16px 1fr auto 60px;
    align-items: center;
    gap: 12px;
    padding: 9px 12px;
    border-radius: 7px;
    font-size: 13.5px;
    transition: background .12s;
  }
  .lf-donut-legend li:hover { background: #f8fafc; }
  .lf-donut-dot {
    width: 14px;
    height: 14px;
    border-radius: 3px;
    flex: none;
    box-shadow: 0 0 0 1px rgba(0,0,0,.06);
  }
  .lf-donut-name {
    font-weight: 650;
    color: #1e293b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .lf-donut-count {
    font-weight: 750;
    font-variant-numeric: tabular-nums;
    text-align: right;
    color: #0f172a;
  }
  .lf-donut-pct {
    color: #64748b;
    font-size: 12.5px;
    font-weight: 650;
    text-align: right;
    font-variant-numeric: tabular-nums;
  }

  /* ---------- Table ---------- */
  .lf-table-wrap { overflow-x: auto; }
  .lf-table { width: 100%; border-collapse: collapse; font-size: 13.5px; }
  .lf-table th {
    text-align: left;
    font-size: 11.5px;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    color: #64748b;
    font-weight: 750;
    padding: 10px 12px;
    border-bottom: 1px solid #e2e6ef;
    white-space: nowrap;
  }
  .lf-table th.sortable { cursor: pointer; user-select: none; }
  .lf-table th.sortable:hover { color: #5b32a3; }
  .lf-table td {
    padding: 12px;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: middle;
    color: #1e293b;
  }
  .lf-table tr.row:hover td { background: #faf8ff; }
  .lf-name { font-weight: 700; color: #0f172a; font-size: 14px; }
  .lf-role {
    display: inline-block;
    margin-left: 8px;
    font-size: 10.5px;
    font-weight: 750;
    padding: 3px 9px;
    border-radius: 999px;
    background: #ede7f6;
    color: #5b32a3;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .lf-num { font-variant-numeric: tabular-nums; font-weight: 750; color: #0f172a; }
  .lf-mix { display: flex; height: 12px; border-radius: 6px; overflow: hidden; background: #eef1f6; min-width: 160px; }
  .lf-mix span { display: block; height: 100%; }
  .lf-attn {
    border: 1px solid #fcd34d;
    background: #fffbeb;
    color: #b45309;
    font-weight: 750;
    font-family: inherit;
    font-size: 12.5px;
    border-radius: 999px;
    padding: 4px 12px;
    cursor: pointer;
    transition: all .12s;
  }
  .lf-attn:hover { background: #fef3c7; }
  .lf-attn.zero { border-color: #e2e6ef; background: #f8fafc; color: #94a3b8; cursor: default; }
  .lf-open {
    border: none;
    background: none;
    color: #5b32a3;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;
    font-size: 13px;
    padding: 5px 10px;
    border-radius: 6px;
    transition: background .12s;
  }
  .lf-open:hover { background: #ede7f6; }

  /* ---------- Empty / error / skeleton ---------- */
  .lf-empty { text-align: center; color: #64748b; padding: 40px 12px; font-size: 14px; font-weight: 550; }
  .lf-error { text-align: center; padding: 52px 12px; color: #b91c1c; font-size: 14.5px; font-weight: 650; }
  .lf-skel {
    background: linear-gradient(90deg, #eef1f6 25%, #f8fafc 50%, #eef1f6 75%);
    background-size: 200% 100%;
    animation: lf-shimmer 1.2s infinite;
    border-radius: 10px;
  }
  @keyframes lf-shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
  .lf-dim { opacity: .55; pointer-events: none; transition: opacity .15s; }
  .lf-more { text-align: center; margin-top: 14px; }
  .lf-save { font-size: 12.5px; color: #64748b; min-width: 80px; font-weight: 600; }

  /* ---------- Drawer ---------- */
  .lf-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15,23,42,.45);
    z-index: 50;
    display: flex;
    justify-content: flex-end;
    backdrop-filter: blur(2px);
  }
  .lf-drawer {
    background: #fff;
    width: min(560px, 100%);
    height: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: -8px 0 32px rgba(15,23,42,.18);
  }
  .lf-drawer-head {
    padding: 18px 22px;
    border-bottom: 1px solid #e2e6ef;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .lf-drawer-head h3 { margin: 0; font-size: 17px; font-weight: 750; color: #0f172a; letter-spacing: -0.2px; }
  .lf-drawer-body { padding: 16px 22px 28px; overflow-y: auto; flex: 1; }
  .lf-lead { border: 1px solid #e2e6ef; border-radius: 10px; padding: 13px 15px; margin-bottom: 12px; transition: border-color .12s; }
  .lf-lead:hover { border-color: #cbd5e1; }
  .lf-lead-top { display: flex; justify-content: space-between; gap: 8px; align-items: center; }
  .lf-lead-name { font-weight: 750; color: #0f172a; font-size: 14.5px; }
  .lf-lead-meta { font-size: 12.5px; color: #64748b; margin-top: 6px; display: flex; flex-wrap: wrap; gap: 6px 16px; font-weight: 500; }
  .lf-pill {
    font-size: 11.5px;
    font-weight: 750;
    padding: 3px 10px;
    border-radius: 999px;
    color: #fff;
    white-space: nowrap;
    letter-spacing: 0.2px;
    text-shadow: 0 1px 1px rgba(0,0,0,.12);
  }
  .lf-days {
    font-size: 12px;
    font-weight: 750;
    color: #b45309;
    background: #fffbeb;
    border: 1px solid #fcd34d;
    border-radius: 999px;
    padding: 3px 10px;
    white-space: nowrap;
  }

  /* ---------- Responsive ---------- */
  @media (max-width: 760px) {
    .lf-top { padding: 14px 16px; }
    .lf-body { padding: 16px 16px 0; }
    .lf-title { font-size: 19px; }
    .lf-kpi-value { font-size: 26px; }
    .lf-funnel-row { grid-template-columns: 100px 1fr 48px; }
    .lf-donut-chart { flex: 1 1 100%; width: 100%; height: 280px; }
    .lf-donut-legend { flex: 1 1 100%; max-height: none; }
  }
`;

const StatusChips = ({ items, hidden, colorOf, onReorder, onToggle }) => {
  const [dragFrom, setDragFrom] = useState(null);
  const [over, setOver] = useState(null);

  const move = (from, to) => {
    if (from === null || to === null || from === to) return;
    if (to < 0 || to >= items.length) return;
    const next = items.slice();
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);
    onReorder(next);
  };

  return (
    <div className="lf-chips">
      {items.map((s, i) => (
        <div
          key={s}
          draggable
          className={`lf-chip ${hidden.has(s) ? "hidden" : ""} ${dragFrom === i ? "drag" : ""} ${over === i && dragFrom !== i ? "over" : ""}`}
          onDragStart={(e) => {
            setDragFrom(i);
            e.dataTransfer.effectAllowed = "move";
            e.dataTransfer.setData("text/plain", s);
          }}
          onDragOver={(e) => {
            e.preventDefault();
            setOver(i);
          }}
          onDragLeave={() => setOver((cur) => (cur === i ? null : cur))}
          onDrop={(e) => {
            e.preventDefault();
            move(dragFrom, i);
            setDragFrom(null);
            setOver(null);
          }}
          onDragEnd={() => {
            setDragFrom(null);
            setOver(null);
          }}
        >
          <span className="lf-chip-grip" aria-hidden="true">
            ⋮⋮
          </span>
          <button
            type="button"
            className="lf-chip-arrow"
            aria-label={`Move ${s} earlier`}
            disabled={i === 0}
            onClick={() => move(i, i - 1)}
          >
            ‹
          </button>
          <span className="lf-chip-dot" style={{ background: colorOf(s) }} />
          <button
            type="button"
            className="lf-chip-name"
            title={hidden.has(s) ? "Click to show" : "Click to hide"}
            onClick={() => onToggle(s)}
          >
            {s}
          </button>
          <button
            type="button"
            className="lf-chip-arrow"
            aria-label={`Move ${s} later`}
            disabled={i === items.length - 1}
            onClick={() => move(i, i + 1)}
          >
            ›
          </button>
        </div>
      ))}
    </div>
  );
};

const FunnelChart = ({ rows, total, colorOf }) => {
  const max = Math.max(1, ...rows.map((r) => r.count));
  return (
    <div className="lf-funnel" role="list">
      {rows.map((r) => {
        const width = Math.max(6, (r.count / max) * 100);
        return (
          <div
            key={r.status}
            className="lf-funnel-row"
            role="listitem"
            title={`${r.status}: ${fmt(r.count)} leads (${pctOf(r.count, total).toFixed(1)}% of total)`}
          >
            <div className="lf-funnel-label">{r.status}</div>
            <div className="lf-funnel-track">
              <div
                className="lf-funnel-bar"
                style={{ width: `${width}%`, background: colorOf(r.status) }}
              >
                {fmt(r.count)}
              </div>
            </div>
            <div className="lf-funnel-pct">
              {pctOf(r.count, total).toFixed(1)}%
            </div>
          </div>
        );
      })}
    </div>
  );
};

const PyramidChart = ({ rows, total, colorOf }) => {
  const W = 700;
  const H = 400;
  const top = 12;
  const bottom = H - 12;
  const pad = 16;
  const cx = W / 2 - 40;
  const usable = bottom - top;
  const sum = rows.reduce((a, r) => a + r.count, 0) || 1;
  const raw = rows.map((r) => Math.max(0.055, r.count / sum));
  const rawSum = raw.reduce((a, b) => a + b, 0);
  const heights = raw.map((h) => (h / rawSum) * usable);
  const halfAt = (y) => ((y - top) / usable) * (cx - pad);

  let y = top;
  const layers = rows.map((r, i) => {
    const y0 = y;
    const y1 = y + heights[i];
    y = y1;
    const a = halfAt(y0);
    const b = halfAt(y1 - 1);
    const label = `${r.status} · ${fmt(r.count)}`;
    const est = label.length * 7.2;
    const midHalf = (halfAt(y0) + halfAt(y1)) / 2;
    let inside = midHalf * 2 - 18 >= est && heights[i] >= 18;
    const outsideFits = cx + midHalf + 10 + est <= W - 4;
    if (!inside && !outsideFits) inside = true;
    return {
      key: r.status,
      points: `${cx - a},${y0} ${cx + a},${y0} ${cx + b},${y1 - 1} ${cx - b},${y1 - 1}`,
      mid: (y0 + y1) / 2,
      midHalf,
      label,
      inside,
      color: colorOf(r.status),
      tip: `${r.status}: ${fmt(r.count)} leads (${pctOf(r.count, total).toFixed(1)}% of total)`,
    };
  });

  return (
    <svg
      className="lf-pyramid"
      viewBox={`0 0 ${W} ${H}`}
      role="img"
      aria-label="Lead pyramid by status"
    >
      {layers.map((l) => (
        <g key={l.key} className="layer">
          <title>{l.tip}</title>
          <polygon points={l.points} fill={l.color} />
          <text
            x={l.inside ? cx : cx + l.midHalf + 10}
            y={l.mid + 5}
            textAnchor={l.inside ? "middle" : "start"}
            fontSize="13"
            fontWeight="700"
            fontFamily='"Inter","Segoe UI",-apple-system,sans-serif'
            fill={l.inside ? "#fff" : "#0f172a"}
          >
            {l.label}
          </text>
        </g>
      ))}
    </svg>
  );
};

const SingleChart = ({ type, rows, total, colorOf }) => {
  const labels = rows.map((r) => r.status);
  const values = rows.map((r) => r.count);
  const colors = rows.map((r) => colorOf(r.status));

  const tooltipLabel = (ctx) => {
    const v = ctx.parsed.y ?? ctx.parsed.x ?? ctx.parsed;
    return ` ${fmt(v)} leads (${pctOf(v, total).toFixed(1)}%)`;
  };

  if (type === "funnel")
    return <FunnelChart rows={rows} total={total} colorOf={colorOf} />;
  if (type === "pyramid")
    return <PyramidChart rows={rows} total={total} colorOf={colorOf} />;

  if (type === "bar") {
    return (
      <div
        className="lf-chart-box"
        style={{ height: Math.max(220, rows.length * 38 + 54) }}
      >
        <Bar
          data={{
            labels,
            datasets: [
              {
                data: values,
                backgroundColor: colors,
                borderRadius: 6,
                maxBarThickness: 28,
              },
            ],
          }}
          options={{
            indexAxis: "y",
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: { label: tooltipLabel },
                titleFont: { family: "Inter, Segoe UI, sans-serif", size: 13, weight: "700" },
                bodyFont: { family: "Inter, Segoe UI, sans-serif", size: 13 },
              },
            },
            scales: {
              x: {
                beginAtZero: true,
                grid: { color: "#eef1f6" },
                ticks: { color: "#475569", font: { family: "Inter, Segoe UI, sans-serif", size: 12, weight: "600" } },
              },
              y: {
                grid: { display: false },
                ticks: { color: "#1e293b", font: { family: "Inter, Segoe UI, sans-serif", size: 12.5, weight: "650" } },
              },
            },
          }}
        />
      </div>
    );
  }

  if (type === "line") {
    return (
      <div className="lf-chart-box" style={{ height: 340 }}>
        <Line
          data={{
            labels,
            datasets: [
              {
                data: values,
                borderColor: "#673AB7",
                backgroundColor: "rgba(103,58,183,0.14)",
                pointBackgroundColor: colors,
                pointBorderColor: "#fff",
                pointRadius: 6,
                pointHoverRadius: 8,
                borderWidth: 2.5,
                tension: 0.3,
                fill: true,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: { label: tooltipLabel },
                titleFont: { family: "Inter, Segoe UI, sans-serif", size: 13, weight: "700" },
                bodyFont: { family: "Inter, Segoe UI, sans-serif", size: 13 },
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                grid: { color: "#eef1f6" },
                ticks: { color: "#475569", font: { family: "Inter, Segoe UI, sans-serif", size: 12, weight: "600" } },
              },
              x: {
                grid: { display: false },
                ticks: { color: "#1e293b", font: { family: "Inter, Segoe UI, sans-serif", size: 12.5, weight: "650" } },
              },
            },
          }}
        />
      </div>
    );
  }

  // Doughnut
  return (
    <div className="lf-donut-wrap">
      <div className="lf-donut-chart">
        <Doughnut
          data={{
            labels,
            datasets: [
              { data: values, backgroundColor: colors, borderWidth: 2, borderColor: "#fff" },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            cutout: "62%",
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: { label: tooltipLabel },
                titleFont: { family: "Inter, Segoe UI, sans-serif", size: 13, weight: "700" },
                bodyFont: { family: "Inter, Segoe UI, sans-serif", size: 13 },
              },
            },
          }}
        />
        <div className="lf-donut-center">
          <b>{fmt(total)}</b>
          <span>Leads</span>
        </div>
      </div>

      <ul className="lf-donut-legend">
        {rows.map((r) => (
          <li key={r.status} title={`${r.status}: ${fmt(r.count)} leads`}>
            <span
              className="lf-donut-dot"
              style={{ background: colorOf(r.status) }}
            />
            <span className="lf-donut-name">{r.status}</span>
            <span className="lf-donut-count">{fmt(r.count)}</span>
            <span className="lf-donut-pct">
              {pctOf(r.count, total).toFixed(1)}%
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const CompareChart = ({ nodes, statuses, colorOf, mode, onDrill }) => {
  const maps = useMemo(() => nodes.map((n) => toCountMap(n.statuses)), [nodes]);
  const labels = nodes.map((n) => n.name);

  const datasets = statuses.map((s) => ({
    label: s,
    backgroundColor: colorOf(s),
    borderColor: colorOf(s),
    borderWidth: mode === "lines" ? 2.5 : 0,
    borderRadius: mode === "lines" ? 0 : 3,
    tension: 0.25,
    pointRadius: mode === "lines" ? 3 : 0,
    fill: false,
    data: nodes.map((n, i) => {
      const v = maps[i][s] || 0;
      return mode === "share" ? +pctOf(v, n.totalLeads).toFixed(1) : v;
    }),
  }));

  const handleClick = (_evt, elements) => {
    if (!elements || !elements.length) return;
    const node = nodes[elements[0].index];
    if (node && node.drillable) onDrill(node);
  };

  const common = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: handleClick,
    interaction: { mode: "nearest", intersect: true },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 13,
          boxHeight: 13,
          padding: 14,
          color: "#1e293b",
          font: { family: "Inter, Segoe UI, sans-serif", size: 12.5, weight: "600" },
        },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const v = ctx.parsed.x ?? ctx.parsed.y;
            return mode === "share"
              ? ` ${ctx.dataset.label}: ${v}%`
              : ` ${ctx.dataset.label}: ${fmt(v)}`;
          },
        },
        titleFont: { family: "Inter, Segoe UI, sans-serif", size: 13, weight: "700" },
        bodyFont: { family: "Inter, Segoe UI, sans-serif", size: 13 },
      },
    },
  };

  if (mode === "lines") {
    return (
      <div className="lf-chart-box" style={{ height: 380 }}>
        <Line
          data={{ labels, datasets }}
          options={{
            ...common,
            scales: {
              y: {
                beginAtZero: true,
                grid: { color: "#eef1f6" },
                ticks: { color: "#475569", font: { family: "Inter, Segoe UI, sans-serif", size: 12, weight: "600" } },
              },
              x: {
                grid: { display: false },
                ticks: { color: "#1e293b", font: { family: "Inter, Segoe UI, sans-serif", size: 12.5, weight: "650" } },
              },
            },
          }}
        />
      </div>
    );
  }

  const stacked = mode === "stacked" || mode === "share";
  const perNode = stacked ? 32 : Math.max(30, statuses.length * 12 + 12);
  return (
    <div
      className="lf-chart-box"
      style={{ height: Math.max(280, nodes.length * perNode + 120) }}
    >
      <Bar
        data={{ labels, datasets }}
        options={{
          ...common,
          indexAxis: "y",
          scales: {
            x: {
              stacked,
              beginAtZero: true,
              max: mode === "share" ? 100 : undefined,
              grid: { color: "#eef1f6" },
              ticks: {
                color: "#475569",
                font: { family: "Inter, Segoe UI, sans-serif", size: 12, weight: "600" },
                ...(mode === "share" ? { callback: (v) => `${v}%` } : {}),
              },
            },
            y: {
              stacked,
              grid: { display: false },
              ticks: { color: "#1e293b", font: { family: "Inter, Segoe UI, sans-serif", size: 12.5, weight: "650" } },
            },
          },
        }}
      />
    </div>
  );
};

const MixBar = ({ node, order, colorOf }) => {
  const map = toCountMap(node.statuses);
  return (
    <div className="lf-mix">
      {order
        .filter((s) => map[s] > 0)
        .map((s) => (
          <span
            key={s}
            title={`${s}: ${fmt(map[s])}`}
            style={{
              width: `${pctOf(map[s], node.totalLeads)}%`,
              background: colorOf(s),
            }}
          />
        ))}
    </div>
  );
};

const AttentionDrawer = ({ state, onClose, onMore, colorOf }) => {
  if (!state.open) return null;
  return (
    <div className="lf-overlay" onClick={onClose}>
      <div
        className="lf-drawer"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="lf-drawer-head">
          <h3>{state.title}</h3>
          <button type="button" className="lf-btn" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="lf-drawer-body">
          {state.error && (
            <div className="lf-error">Could not load these leads.</div>
          )}
          {!state.error && !state.loading && state.items.length === 0 && (
            <div className="lf-empty">
              Nothing needs attention here. Nice work.
            </div>
          )}
          {state.items.map((l) => (
            <div className="lf-lead" key={l.leadId}>
              <div className="lf-lead-top">
                <span className="lf-lead-name">{l.name || "Unnamed lead"}</span>
                <span className="lf-days">{l.daysInStatus}d in status</span>
              </div>
              <div className="lf-lead-meta">
                <span
                  className="lf-pill"
                  style={{ background: colorOf(l.status || "") }}
                >
                  {l.status || "Unknown"}
                </span>
                {l.phone && <span>{l.phone}</span>}
                <span>{l.executiveName || "Unassigned"}</span>
                {l.projectName && <span>{l.projectName}</span>}
                <span>Last interaction: {daysLabel(l.daysSinceLastInteraction)}</span>
              </div>
            </div>
          ))}
          {state.loading && (
            <div className="lf-skel" style={{ height: 70, marginBottom: 10 }} />
          )}
          {state.hasNext && !state.loading && (
            <div className="lf-more">
              <button type="button" className="lf-btn" onClick={onMore}>
                Load more
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const LeadFunnel = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const userId = user?.id;

  const [nodeId, setNodeId] = useState(null);
  const [view, setView] = useState("overview");
  const [level, setLevel] = useState("DIRECT");
  const [chartType, setChartType] = useState("funnel");
  const [compareMode, setCompareMode] = useState("stacked");
  const [showEmpty, setShowEmpty] = useState(false);
  const [hidden, setHidden] = useState(() => new Set());
  const [order, setOrder] = useState([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saveState, setSaveState] = useState("");
  const [sort, setSort] = useState({ key: "total", dir: "desc" });
  const [compareLimit, setCompareLimit] = useState(COMPARE_LIMIT_STEP);
  const [attn, setAttn] = useState({
    open: false,
    title: "",
    params: {},
    items: [],
    page: 0,
    hasNext: false,
    loading: false,
    error: false,
  });

  const reqRef = useRef(0);
  const saveTimer = useRef(null);
  const attnReq = useRef(0);

  const levelParam = view === "compare" && level !== "DIRECT" ? level : "";

  const load = useCallback(
    async (silent) => {
      if (!userId) return;
      const id = ++reqRef.current;
      if (!silent) setLoading(true);
      try {
        const r = await axios.get(
          `${API_URL}/api/lead-insights/funnel/${userId}`,
          {
            headers: authHeader(),
            params: {
              nodeId: nodeId || undefined,
              level: levelParam || undefined,
            },
          },
        );
        if (id !== reqRef.current) return;
        setData(r.data);
        setError(null);
        setOrder((prev) => mergeOrder(prev, r.data.statusList));
      } catch (e) {
        if (id !== reqRef.current) return;
        setError(e.response?.status === 403 ? "forbidden" : "failed");
      } finally {
        if (id === reqRef.current) setLoading(false);
      }
    },
    [userId, nodeId, levelParam],
  );

  useEffect(() => {
    load(false);
  }, [load]);

  useEffect(() => {
    const t = setInterval(() => {
      if (!document.hidden) load(true);
    }, 60000);
    return () => clearInterval(t);
  }, [load]);

  useEffect(() => {
    if (!userId) return;
    axios
      .get(`${API_URL}/api/lead-insights/funnel-preferences/${userId}`, {
        headers: authHeader(),
      })
      .then((r) => {
        const saved = r.data?.statusOrder || [];
        setOrder((prev) => mergeOrder(saved, prev));
        if (SINGLE_CHARTS.some((c) => c.key === r.data?.chartType)) {
          setChartType(r.data.chartType);
        }
      })
      .catch(() => {});
  }, [userId]);

  useEffect(() => () => clearTimeout(saveTimer.current), []);

  const savePrefs = useCallback(
    (body, delay) => {
      if (!userId) return;
      clearTimeout(saveTimer.current);
      setSaveState("Saving…");
      saveTimer.current = setTimeout(() => {
        axios
          .put(
            `${API_URL}/api/lead-insights/funnel-preferences/${userId}`,
            body,
            { headers: authHeader() },
          )
          .then(() => setSaveState("Saved"))
          .catch(() => setSaveState("Could not save"));
      }, delay);
    },
    [userId],
  );

  const present = useMemo(() => data?.statusList || [], [data]);

  const orderedPresent = useMemo(
    () => order.filter((s) => present.includes(s)),
    [order, present],
  );

  const colorOf = useMemo(() => {
    const names = [...new Set([...order, ...present])].sort((a, b) =>
      a.localeCompare(b),
    );
    const index = new Map(names.map((n, i) => [n, i]));
    return (s) => PALETTE[(index.get(s) ?? 0) % PALETTE.length];
  }, [order, present]);

  const onReorder = (nextPresent) => {
    const nextFull = applyPresentOrder(order, orderedPresent, nextPresent);
    setOrder(nextFull);
    savePrefs({ statusOrder: nextFull }, 500);
  };

  const onToggleStatus = (s) =>
    setHidden((prev) => {
      const next = new Set(prev);
      if (next.has(s)) next.delete(s);
      else next.add(s);
      return next;
    });

  const onChartType = (key) => {
    setChartType(key);
    savePrefs({ chartType: key }, 0);
  };

  const drill = (entry) => {
    if (!entry || !entry.drillable) return;
    setNodeId(entry.id);
    setView("overview");
    setLevel("DIRECT");
    setCompareLimit(COMPARE_LIMIT_STEP);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const totalLeads = data?.total?.totalLeads || 0;
  const totalMap = useMemo(() => toCountMap(data?.total?.statuses), [data]);

  const singleRows = useMemo(
    () =>
      orderedPresent
        .filter((s) => !hidden.has(s))
        .map((s) => ({ status: s, count: totalMap[s] || 0 }))
        .filter((r) => showEmpty || r.count > 0),
    [orderedPresent, hidden, totalMap, showEmpty],
  );

  const levelReady =
    level === "DIRECT" || (data?.levelRole || "").toUpperCase() === level;

  const compareNodes = useMemo(() => {
    if (view !== "compare" || !data || !levelReady) return [];
    const list = level === "DIRECT" ? data.children : data.levelNodes;
    return (list || []).filter((n) => n.totalLeads > 0 || showEmpty);
  }, [view, data, level, levelReady, showEmpty]);

  const shownCompareNodes = useMemo(
    () => compareNodes.slice(0, compareLimit),
    [compareNodes, compareLimit],
  );

  const compareStatuses = useMemo(() => {
    const maps = shownCompareNodes.map((n) => toCountMap(n.statuses));
    return orderedPresent
      .filter((s) => !hidden.has(s))
      .filter((s) => showEmpty || maps.some((m) => (m[s] || 0) > 0));
  }, [shownCompareNodes, orderedPresent, hidden, showEmpty]);

  const tableRows = useMemo(() => {
    const rows = (data?.children || []).slice();
    const dir = sort.dir === "asc" ? 1 : -1;
    rows.sort((a, b) => {
      if (sort.key === "name") return dir * a.name.localeCompare(b.name);
      if (sort.key === "attention") return dir * (a.attention - b.attention);
      return dir * (a.totalLeads - b.totalLeads);
    });
    return rows;
  }, [data, sort]);

  const toggleSort = (key) =>
    setSort((cur) =>
      cur.key === key
        ? { key, dir: cur.dir === "asc" ? "desc" : "asc" }
        : { key, dir: key === "name" ? "asc" : "desc" },
    );

  const sortMark = (key) =>
    sort.key === key ? (sort.dir === "asc" ? " ▲" : " ▼") : "";

  const fetchAttention = useCallback(
    async (params, page, replace) => {
      const id = ++attnReq.current;
      setAttn((cur) => ({ ...cur, loading: true, error: false }));
      try {
        const r = await axios.get(
          `${API_URL}/api/lead-insights/needs-attention/${userId}`,
          { headers: authHeader(), params: { page, size: 25, ...params } },
        );
        if (id !== attnReq.current) return;
        setAttn((cur) => ({
          ...cur,
          loading: false,
          page,
          hasNext: !!r.data.hasNext,
          items: replace ? r.data.items : [...cur.items, ...r.data.items],
        }));
      } catch (e) {
        if (id !== attnReq.current) return;
        setAttn((cur) => ({ ...cur, loading: false, error: true }));
      }
    },
    [userId],
  );

  const openAttention = (entry) => {
    if (!entry || entry.listable === false) return;
    const params =
      entry.id === "UNASSIGNED"
        ? { executiveId: "UNASSIGNED" }
        : { nodeId: entry.id };
    setAttn({
      open: true,
      title: `${entry.name} · needs attention`,
      params,
      items: [],
      page: 0,
      hasNext: false,
      loading: true,
      error: false,
    });
    fetchAttention(params, 0, true);
  };

  const closeAttention = () => {
    attnReq.current += 1;
    setAttn((cur) => ({ ...cur, open: false }));
  };

  if (error === "forbidden") {
    return (
      <>
        <style>{LF_CSS}</style>
        <div className="lf-root">
          <div className="lf-error">
            You do not have access to Leads, so the funnel is unavailable.
          </div>
        </div>
      </>
    );
  }

  const node = data?.node;
  const attention = data?.total?.attention || 0;
  const ownLeads = data?.own?.totalLeads || 0;
  const hasChildren = (data?.children || []).length > 0;

  return (
    <>
      <style>{LF_CSS}</style>
      <div className="lf-root">
        <div className="lf-top">
          <div>
            <h1 className="lf-title">Lead Funnel</h1>
            <p className="lf-sub">
              {data
                ? `Updated ${new Date(data.generatedAt).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })} · attention = no status change for ${data.staleAfterDays}+ days`
                : "Loading…"}
            </p>
          </div>
          <div className="lf-actions">
            <span className="lf-save">{saveState}</span>
            <button
              type="button"
              className="lf-btn"
              onClick={() => load(false)}
              disabled={loading}
            >
              Refresh
            </button>
            <button
              type="button"
              className="lf-btn primary"
              onClick={() => navigate("/dashboard")}
            >
              ← Dashboard
            </button>
          </div>
        </div>

        <div className="lf-body">
          {error === "failed" && !data && (
            <div className="lf-error">
              Could not load the funnel.{" "}
              <button type="button" className="lf-btn" onClick={() => load(false)}>
                Try again
              </button>
            </div>
          )}

          {!data && !error && (
            <>
              <div className="lf-skel" style={{ height: 90 }} />
              <div className="lf-skel" style={{ height: 380 }} />
            </>
          )}

          {data && (
            <div className={loading ? "lf-dim" : ""} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <div className="lf-crumbs">
                {(data.breadcrumb || []).map((c, i, arr) => {
                  const last = i === arr.length - 1;
                  return (
                    <span key={c.id} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                      <button
                        type="button"
                        className={`lf-crumb ${last ? "last" : ""}`}
                        onClick={() => !last && setNodeId(c.id)}
                      >
                        {c.name}
                      </button>
                      {!last && <span className="lf-crumb-sep">›</span>}
                    </span>
                  );
                })}
                {node && <span className="lf-role">{roleLabel(node.role)}</span>}
              </div>

              <div className="lf-kpis">
                <div className="lf-kpi">
                  <div className="lf-kpi-label">Total leads</div>
                  <div className="lf-kpi-value">{fmt(totalLeads)}</div>
                  <div className="lf-kpi-sub">
                    {hasChildren ? "Including everyone below" : "Assigned to this person"}
                  </div>
                </div>
                <button
                  type="button"
                  className="lf-kpi warn"
                  onClick={() => openAttention(node)}
                  disabled={attention === 0}
                >
                  <div className="lf-kpi-label">Needs attention</div>
                  <div className="lf-kpi-value">{fmt(attention)}</div>
                  <div className="lf-kpi-sub">
                    {pctOf(attention, totalLeads).toFixed(1)}% of leads · click to view
                  </div>
                </button>
                <div className="lf-kpi">
                  <div className="lf-kpi-label">Statuses in play</div>
                  <div className="lf-kpi-value">{fmt(singleRows.filter((r) => r.count > 0).length)}</div>
                  <div className="lf-kpi-sub">With at least one lead</div>
                </div>
                {hasChildren && (
                  <div className="lf-kpi">
                    <div className="lf-kpi-label">Held directly</div>
                    <div className="lf-kpi-value">{fmt(ownLeads)}</div>
                    <div className="lf-kpi-sub">
                      Leads assigned to {node?.name || "this person"} themselves
                    </div>
                  </div>
                )}
              </div>

              <div className="lf-card">
                <div className="lf-card-head">
                  <h2 className="lf-card-title">Status order</h2>
                  <label className="lf-check">
                    <input
                      type="checkbox"
                      checked={showEmpty}
                      onChange={(e) => setShowEmpty(e.target.checked)}
                    />
                    Show empty statuses
                  </label>
                </div>
                <StatusChips
                  items={orderedPresent}
                  hidden={hidden}
                  colorOf={colorOf}
                  onReorder={onReorder}
                  onToggle={onToggleStatus}
                />
                <p className="lf-hint">
                  Drag a status (or use the arrows) to set the order. It is saved for you. Click a name to hide or show it.
                </p>
              </div>

              <div className="lf-card">
                <div className="lf-card-head">
                  <div className="lf-seg" role="group" aria-label="View">
                    <button
                      type="button"
                      className={view === "overview" ? "on" : ""}
                      aria-pressed={view === "overview"}
                      onClick={() => setView("overview")}
                    >
                      {node?.name ? `${node.name}` : "Overview"}
                    </button>
                    <button
                      type="button"
                      className={view === "compare" ? "on" : ""}
                      aria-pressed={view === "compare"}
                      onClick={() => setView("compare")}
                    >
                      Compare side by side
                    </button>
                  </div>

                  <div className="lf-toolbar">
                    {view === "compare" && (
                      <select
                        className="lf-select"
                        value={level}
                        onChange={(e) => {
                          setLevel(e.target.value);
                          setCompareLimit(COMPARE_LIMIT_STEP);
                        }}
                        aria-label="Compare level"
                      >
                        {LEVELS.map((l) => (
                          <option key={l.key} value={l.key}>
                            {l.label}
                          </option>
                        ))}
                      </select>
                    )}
                    <div className="lf-seg" role="group" aria-label="Chart type">
                      {(view === "compare" ? COMPARE_CHARTS : SINGLE_CHARTS).map((c) => {
                        const active = view === "compare" ? compareMode === c.key : chartType === c.key;
                        return (
                          <button
                            key={c.key}
                            type="button"
                            className={active ? "on" : ""}
                            aria-pressed={active}
                            onClick={() =>
                              view === "compare" ? setCompareMode(c.key) : onChartType(c.key)
                            }
                          >
                            {c.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {view === "overview" && (
                  <>
                    {singleRows.length === 0 ? (
                      <div className="lf-empty">No leads to show for this selection yet.</div>
                    ) : (
                      <SingleChart
                        type={chartType}
                        rows={singleRows}
                        total={totalLeads}
                        colorOf={colorOf}
                      />
                    )}
                  </>
                )}

                {view === "compare" && (
                  <>
                    {!levelReady && <div className="lf-skel" style={{ height: 280 }} />}
                    {levelReady && shownCompareNodes.length === 0 && (
                      <div className="lf-empty">
                        No {LEVELS.find((l) => l.key === level)?.label.toLowerCase()} with leads under {node?.name}.
                      </div>
                    )}
                    {levelReady && shownCompareNodes.length > 0 && (
                      <>
                        <CompareChart
                          nodes={shownCompareNodes}
                          statuses={compareStatuses}
                          colorOf={colorOf}
                          mode={compareMode}
                          onDrill={drill}
                        />
                        <p className="lf-hint">Click a bar to open that person's funnel.</p>
                        {compareNodes.length > shownCompareNodes.length && (
                          <div className="lf-more">
                            <button
                              type="button"
                              className="lf-btn"
                              onClick={() => setCompareLimit((n) => n + COMPARE_LIMIT_STEP)}
                            >
                              Show more ({compareNodes.length - shownCompareNodes.length} left)
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>

              {hasChildren && (
                <div className="lf-card">
                  <div className="lf-card-head">
                    <h2 className="lf-card-title">
                      {node?.role === "COMPANY" ? "Teams and people" : `Reporting to ${node?.name}`}
                    </h2>
                  </div>
                  <div className="lf-table-wrap">
                    <table className="lf-table">
                      <thead>
                        <tr>
                          <th className="sortable" onClick={() => toggleSort("name")}>
                            Name{sortMark("name")}
                          </th>
                          <th className="sortable" onClick={() => toggleSort("total")}>
                            Leads{sortMark("total")}
                          </th>
                          <th>Status mix</th>
                          <th className="sortable" onClick={() => toggleSort("attention")}>
                            Needs attention{sortMark("attention")}
                          </th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {tableRows.map((row) => (
                          <tr className="row" key={row.id}>
                            <td>
                              <span className="lf-name">{row.name}</span>
                              <span className="lf-role">{roleLabel(row.role)}</span>
                            </td>
                            <td className="lf-num">{fmt(row.totalLeads)}</td>
                            <td>
                              <MixBar node={row} order={orderedPresent} colorOf={colorOf} />
                            </td>
                            <td>
                              <button
                                type="button"
                                className={`lf-attn ${row.attention === 0 || row.listable === false ? "zero" : ""}`}
                                disabled={row.attention === 0 || row.listable === false}
                                onClick={() => openAttention(row)}
                              >
                                {fmt(row.attention)}
                              </button>
                            </td>
                            <td>
                              {row.drillable && (
                                <button type="button" className="lf-open" onClick={() => drill(row)}>
                                  Open ›
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <AttentionDrawer
          state={attn}
          onClose={closeAttention}
          onMore={() => fetchAttention(attn.params, attn.page + 1, false)}
          colorOf={colorOf}
        />
      </div>
    </>
  );
};

export default LeadFunnel;

